import jpMorganLogo from "../img/testimoniesJS/logoJP.svg";
import balloonLogo from "../img/testimoniesJS/logoBalloon.svg";
import cloudGaiaImg from "../img/CloudGaiaSalesforceBc.png";
import salesforcePartnerImg from "../img/SalesforcePartner.png";
import salesforceBackgroundImg from "../img/SalesforceMainImage.svg";
import javascriptMainBackgroundImg from "../img/Bootcamp-js.svg";
import dotBackgroundImg from "../img/DotImage.png";
import salesforceCupIcon from "../img/SalesforceCup.png";
import salesforceJobIcon from "../img/SalesforceJob.png";
import salesforceSalaryIcon from "../img/SalesforceSalary.png";
import javascriptCupIcon from "../img/Js Cup.png";
import javascriptPCIcon from "../img/Js Vector.png";
import javascriptGroupIcon from "../img/Js Group.png";
import salesforceGuy from "../img/SalesforceGuy.png";
import salesforceClockIcon from "../img/SalesforceFullTime.png";
import salesforceCalendarIcon from "../img/SalesforceDuration.png";
import salesforceComputerIcon from "../img/SalesforceRemote.png";
import codeBackground from "../img/SalesforceModalityBc.png";
import javascriptClockIcon from "../img/Bootcamp js clock.svg";
import javascriptCalendarIcon from "../img/Bootcamp js calendar.svg";
import javascriptComputerIcon from "../img/Bootcamp js computer.svg";
import javascriptPersonCoding from "../img/Bootcamp js study.webp";
import salesforceLogo from "../img/LogoSalesforceMobile.png";
import gitLogo from "../img/LogoGitMobile.png";
import sqlLogo from "../img/LogoSqlMobile.png";
import apexLogo from "../img/LogoApexMobile.png";
import salesforceComponentLogo from "../img/LogoMobile.png";
import commandLineLogo from "../img/LogoCommandLineMobile.png";
import scrumLogo from "../img/LogoScrumMobile.png";
import jsLogo from "../img/jsLogo.svg";
import nodejsLogo from "../img/nodejsLogo.svg";
import reactLogo from "../img/reactLogo.svg";
import reduxLogo from "../img/ReduxLogo.svg";
import expressLogo from "../img/expressLogo.svg";
import mongodbLogo from "../img/mongodbLogo.svg";
import githubLogo from "../img/githubLogo.svg";
import bookingMonthsCalendarIcon from "../img/Bootcamp js calendario.svg";
import bookingClockIcon from "../img/Bootcamp js alarm.svg";
import bookingSheetIcon from "../img/Bootcamp js duration.svg";
import bookingComputerIcon from "../img/Bootcamp js modality.svg";
import bookingDaysCalendarIcon from "../img/Bootcamp js days.svg";
import bookingNextMonthSFBCMonthsCalendarIcon from "../img/Calendar2.svg";
import bookingNextMonthSFBCClockIcon from "../img/Clock2.svg";
import bookingNextMonthSFBCSheetIcon from "../img/Duration2.svg";
import bookingNextMonthSFBCComputerIcon from "../img/Modality2.svg";
import bookingNextMonthSFBCDaysCalendarIcon from "../img/Days2.svg";
import bookingNextMonthJSBCMonthsCalendarIcon from "../img/Bootcamp js calendario 2.svg";
import bookingNextMonthJSBCClockIcon from "../img/Bootcamp js alarm 2.svg";
import bookingNextMonthJSBCSheetIcon from "../img/Bootcamp js duration 2.svg";
import bookingNextMonthJSBCComputerIcon from "../img/Bootcamp js modality 2.svg";
import bookingNextMonthJSBCDaysCalendarIcon from "../img/Bootcamp js days 2.svg";
import clockIcon from "../img/TimeCircle.svg";
import facundoGonzalez from "../img/facundoGonzalez.png";
import koibanxLogo from "../img/logoKoibanx.png";
import rosangelysReyes from "../img/rosangelysReyes.png";
import cloudGaiaIcon from "../img/CloudGaia.png";
import rodrigoCadiz from "../img/rodrigoCadiz.png";
import leoCampoy from "../img/leoCampoy.png";
import miguelJesusOyola from "../img/testimoniesJS/MiguelJesusOyola.png";
import logoInteratica from "../img/testimoniesJS/logoInteratica.png";
import diegoHRojas from "../img/testimoniesJS/DiegoHRojas.png";
import reynaldoValencia from "../img/testimoniesJS/ReynaldoValencia.png";
import facundoMuller from "../img/testimoniesJS/FacuMuller.png";
import peopleLogo from "../img/testimoniesJS/logoPeople.png";
import yesicaBarros from "../img/testimoniesJS/YesicaBarros.png";
import julietaPuigPeralta from "../img/testimoniesJS/JulietaPuigPeralta.png";
import globantLogo from "../img/testimoniesJS/logoGlobant.png";
import ignacioRodriguez from "../img/testimoniesJS/IgnacioRodriguez.png";
import maitenPeinetti from "../img/testimoniesJS/MaitenPeinetti.png";
import checkboxLogo from "../img/testimoniesJS/logoCheckbox.png";
import juliaSelma from "../img/testimoniesJS/JuliaSelma.png";
import IBMLogo from "../img/testimoniesJS/logoIBM.png";
import guillermoFedericoNauberger from "../img/testimoniesJS/GuillermoFedericoNauberger.png";
import claudioMazzoli from "../img/testimoniesJS/ClaudioMazzoli.png";
import fizzmodLogo from "../img/testimoniesJS/logoFizzmod.png";
import modelitIcon from "../img/testimoniesJS/logoModelit.png";
import introBackgroundIcon from "../img/Course intro.svg";
import jsbcBackgroundIcon from "../img/Bootcamp-js.svg";
import sfbcBackgroundIcon from "../img/SalesforceMainImage.svg";
import courseReportLogo from "../img/CourseReport.png";
import switchUpLogo from "../img/SwitchUp.png";
import step1 from "../img/Step1.png";
import step2 from "../img/Step2.png";
import step3 from "../img/Step3.png";
import step4 from "../img/Step4.png";
import jobPlacement1 from "../img/JobPlacement1.png";
import jobPlacement2 from "../img/JobPlacement2.png";
import jobPlacement5 from "../img/JobPlacement5.png";
import jobPlacement7 from "../img/JobPlacement7.png";
import jobPlacement10 from "../img/JobPlacement10.png";
import CNNLogo from "../img/Media-Logos/cnn.png";
import diarioPerfilLogo from "../img/LogoDiarioPerfil.png";
import forbesLogo from "../img/Media-Logos/forbes.png";
import infobaeLogo from "../img/Media-Logos/infobae.png";
import infoTechnologyLogo from "../img/Media-Logos/InfoTech.png";
import laNacionLogo from "../img/Media-Logos/LN.png";
import applyIntroLogo from "../img/Apply main intro mobile.svg";
import applyJSLogo from "../img/Apply main js mobile.svg";
import applySalesforceLogo from "../img/Apply main salesforce mobile.svg";
import successIcon from "../img/EmailIlustration.png";
import errorIcon from "../img/ErrorIlustration.png";
import errorBackground from "../img/ErrorBackground.png";
import introBackground from "../img/HomeBlueBackground.png";
import introIcon from "../img/Course intro.svg";
import htmlCSSJSIcon from "../img/Course intro group.webp";
import learnIcon from "../img/Course intro learn.svg";
import worldIcon from "../img/Course intro world.svg";
import JsLogo from "../img/jsLogo.svg";
import HtmlLogo from "../img/HTMLLogo.svg";
import CssLogo from "../img/CSSLogo.svg";
import NetlifyLogo from "../img/netlify.svg";
import BootstrapLogo from "../img/bootstrapLogo.svg";
import JsonLogo from "../img/json.svg";
import VsCodeLogo from "../img/VSCodeLogo.svg";
import introCertificate from "../img/intro-certificate.png";
import dotBackgroundChallengeImg from "../img/HomeDesktop01.png";
import checkListIcon from "../img/CCExercises.svg";
import cupIcon from "../img/CCCup.svg";
import chatIcon from "../img/CCInterview.svg";
import greenCheckIcon from "../img/GreenCheck.svg";
import challengeComputerIcon from "../img/CodingChallengeHiconGlass.svg";
import challengeTimeIcon from "../img/CodingChallengeTimeCircle.svg";
import challengeCalendarIcon from "../img/CodingChallengeCalendar.svg";
import salesforceIcon from "../img/IlustrationSalesforce.png";
import javascriptIcon from "../img/IlustrationJavascript.png";
import salesforceCard from "../img/SalesforceBcCardDesktop.png";
import javascriptCard from "../img/JavascriptBcCardDesktop.png";
import gridBackground from "../img/Miscelanea01LandingBc.png";
import founderPicture from "../img/FounderImage.png";

const en = {
  "/bootcamp/salesforce": {
    // --------------------------------------------------------------- //
    BootcampTitle: {
      title: "Salesforce Bootcamp",
      subtitle: [
        "Aprende a programar ",
        "en Salesforce, la ",
        "plataforma CRM más potente del mundo.",
      ],
      poweredBy: "Powered by",
      companyImg: {
        src: cloudGaiaImg,
        alt: "Logo de CloudGaia: Evolving Together",
      },
      partnerImg: {
        src: salesforcePartnerImg,
        alt: "Logo de Salesforce Partner",
      },
      backgroundLogoImg: {
        src: salesforceBackgroundImg,
        alt: "Logo representativo",
      },
    },
    // --------------------------------------------------------------- //
    BootcampText: {
      dotBackgroundImg: { src: dotBackgroundImg, alt: "Fondo de puntos" },
      content: [
        "Salesforce es ",
        "la plataforma de CRM ",
        "más usada en el ecosistema corporativo. ",
        "Domina esta tecnología y desarrolla ",
        "sistemas de gestión ",
        "de clientes para grandes empresas.",
      ],
    },
    // --------------------------------------------------------------- //
    BenefitsTitle: {
      title: "BENEFICIOS",
      subtitle: ["¿Por qué", " hacerlo?"],
    },
    // --------------------------------------------------------------- //
    CardsBenefitsMobile: {
      cards: [
        {
          img: { src: salesforceCupIcon, alt: "Copa" },
          title: "INSERCIÓN LABORAL",
          subtitle:
            "Todos nuestros graduados que buscaron trabajo lo consiguieron.",
        },
        {
          img: { src: salesforceSalaryIcon, alt: "Dinero" },
          title: "SALARIOS",
          subtitle:
            "Los programadores de Salesforce están entre los mejores pagos del mercado IT.",
        },
        {
          img: { src: salesforceJobIcon, alt: "Maletín" },
          title: "9,3 MILLONES DE NUEVOS PUESTOS DE TRABAJO",
          subtitle:
            "Salesforce es una de las tecnologías con mayor crecimiento en el mundo.",
        },
      ],
    },
    // --------------------------------------------------------------- //
    CardsBenefitsDesktop: {
      cards: [
        {
          img: { src: salesforceCupIcon, alt: "Copa" },
          title: "INSERCIÓN LABORAL",
          subtitle:
            "Todos nuestros graduados que buscaron trabajo lo consiguieron.",
        },
        {
          img: { src: salesforceSalaryIcon, alt: "Dinero" },
          title: "SALARIOS",
          subtitle:
            "Los programadores de Salesforce están entre los mejores pagos del mercado IT.",
        },
        {
          img: { src: salesforceJobIcon, alt: "Maletín" },
          title: "9,3 MILLONES DE NUEVOS PUESTOS DE TRABAJO",
          subtitle:
            "Salesforce es una de las tecnologías con mayor crecimiento en el mundo.",
        },
      ],
    },
    // --------------------------------------------------------------- //
    CourseModalityCardsMobile: {
      title: "INTENSIVO",
      subtitle: ["Modalidad", " de cursada"],
      cards: [
        {
          img: { src: salesforceClockIcon, alt: "Reloj" },
          title: "FULL TIME",
          subtitle: ["Lunes a Viernes", "De 9:30 a 19:00 hs"],
        },
        {
          img: { src: salesforceCalendarIcon, alt: "Calendario" },
          title: "4 MESES",
          subtitle: ["", "Más de 800 hs. ", "de aprendizaje"],
        },
        {
          img: { src: salesforceComputerIcon, alt: "Computadora" },
          title: "REMOTO",
          subtitle: ["Curso 100% online Workshops en vivo"],
        },
      ],
    },
    // --------------------------------------------------------------- //
    CourseModalityCardsDesktop: {
      title: "INTENSIVO",
      subtitle: ["Modalidad de ", "cursada"],
      backgroundImg: { src: codeBackground, alt: "Fondo de código" },
      rightSideImg: {
        src: salesforceGuy,
        alt: "Un chico de Salesforce codeando",
      },
      cards: [
        {
          img: { src: salesforceClockIcon, alt: "Reloj" },
          title: "FULL TIME",
          subtitle: ["Lunes a Viernes", "De 9:30 a 19:00 hs"],
        },
        {
          img: { src: salesforceCalendarIcon, alt: "Calendario" },
          title: "4 MESES",
          subtitle: ["", "Más de 800 hs. de aprendizaje"],
        },
        {
          img: { src: salesforceComputerIcon, alt: "Computadora" },
          title: "REMOTO",
          subtitle: ["Curso 100% online", "Workshops en vivo"],
        },
      ],
      altBackgroundPerson: "Fondo de una persona programando",
    },
    // --------------------------------------------------------------- //
    UnitsCarrousel: {
      title: "CONOCE MÁS",
      subtitle: "Programa",
      button: "Descarga el programa",
      units: [
        {
          unit: "PREP COURSE",
          stage: "",
          period: "80 horas",
          title: "Introducción a Salesforce ",
          lessons: [{ topic: "Java" }, { topic: "SQL" }, { topic: "Git" }],
        },
        {
          unit: "JUNIOR PHASE",
          stage: "",
          period: "1 semana",
          title: "Salesforce Platform (Parte 1)",
          lessons: [
            { topic: "Introducción a la Arquitectura de Salesforce" },
            { topic: "Modelo de Datos en Salesforce" },
            { topic: "Salesforce Platform Basics" },
            { topic: "Lightning Experience Basics" },
            { topic: "Lightning App Builder" },
            { topic: "Modelo CRM" },
            { topic: "Lightning Experience en CRM" },
          ],
        },
        {
          unit: "JUNIOR PHASE",
          stage: "",
          period: "1 semana",
          title: "Salesforce Platform (Parte 2)",
          lessons: [
            { topic: "Reports & Dashboards" },
            { topic: "Data Management" },
            { topic: "Search Solutions" },
            { topic: "Data Modeling" },
            { topic: "Salesforce Security" },
            { topic: "Flows" },
            { topic: "Formulas & Validations" },
            { topic: "Process Builders" },
          ],
        },
        {
          unit: "JUNIOR PHASE",
          stage: "",
          period: "1 semana",
          title: "Backend Development (Parte 1)",
          lessons: [
            { topic: "Introducción a Apex" },
            { topic: "Salesforce Development Lifecycle" },
            { topic: "Platform Development Basics" },
            { topic: "SFDX & Salesforce CLI " },
            { topic: "Apex Basics & Database" },
            { topic: "Developer Console" },
            { topic: "Apex Metadata API" },
          ],
        },
        {
          unit: "JUNIOR PHASE",
          stage: "",
          period: "1 semana",
          title: "Backend Development (Parte 2)",
          lessons: [
            { topic: "Apex Triggers" },
            { topic: "Asynchronous Apex" },
            { topic: "Apex Testing" },
            { topic: "Apex Integration Services" },
            { topic: "Platform Cache Basics" },
            { topic: "Apex Development Patterns" },
            { topic: "Especialización en Apex" },
          ],
        },
        {
          unit: "JUNIOR PHASE",
          stage: "",
          period: "1 semana",
          title: "Frontend Development (Parte 1)",
          lessons: [
            { topic: "Introducción a Lightning" },
            { topic: "Native Javascript" },
            { topic: "Lightning Web Components Basics (LWC)" },
            { topic: "LWC & Salesforce Data" },
            { topic: "Comunicación entre LWCs (eventos)" },
            { topic: "LWC Troubleshooting" },
            { topic: "LWC Tests" },
            { topic: "LWC Escalabilidad" },
          ],
        },
        {
          unit: "JUNIOR PHASE",
          stage: "",
          period: "1 semana",
          title: "Frontend Development (Parte 2)",
          lessons: [
            { topic: "Especialización en LWC" },
            { topic: "Visualforce Basics" },
            { topic: "Aura Basics" },
          ],
        },
        {
          unit: "SENIOR PHASE",
          stage: "",
          period: "2 semanas",
          title: "Proyecto Individual",
          lessons: [
            {
              topic:
                "Aplicarás todo lo aprendido en la Junior Phase. (Solo Weeks).",
            },
            {
              topic: "Git y versionado",
            },
          ],
        },
        {
          unit: "SENIOR PHASE",
          stage: "",
          period: "4 semanas",
          title: "Proyecto Final",
          lessons: [
            { topic: "Programación Declarativa" },
            { topic: "Desarrollo en Apex y LWC" },
            { topic: "Metodologías Ágiles" },
            { topic: "División de Tareas " },
            { topic: "Herramientas de Gestión de Proyectos" },
            { topic: "Uso de Repositorios de Código" },
            { topic: "Diseño y Arquitectura de la Solución " },
            { topic: "Modelo de Datos" },
          ],
        },
        {
          unit: "POST BOOTCAMP",
          stage: "",
          period: "2 semanas",
          title: "Job Placement",
          lessons: [
            { topic: "Estrategia de búsqueda laboral" },
            { topic: "Preparación de CV + perfil en LinkedIn" },
            { topic: "Simulación de entrevistas" },
            { topic: "MeetUps con empresas IT" },
          ],
        },
      ],
    },
    // --------------------------------------------------------------- //
    Tools: {
      title: "HERRAMIENTAS",
      subtitle: "Aprenderás a usar",
      logosImg: [
        { src: salesforceLogo, alt: "Logo Salesforce" },
        { src: gitLogo, alt: "Logo Git" },
        { src: sqlLogo, alt: "Logo Sql" },
        { src: apexLogo, alt: "Logo Apex" },
        { src: salesforceComponentLogo, alt: "Logo Componente" },
        { src: commandLineLogo, alt: "Logo CommandLine" },
        { src: scrumLogo, alt: "Logo Scrum" },
      ],
    },
    Funding: {
      title: "INVERSIÓN",
      subtitle: ["", "Nuestros planes"],
      options: [
        "Contamos con ",
        "tres opciones:",
        " Contado, Diferido y Full Diferido.",
      ],
      note: "El 70 % de nuestros alumnos recibe algún tipo de financiación.",
      cards: [
        {
          title: "CONTADO",
          content: {
            paymentDescription: [
              "Paga de forma anticipada y aprovecha el ",
              "descuento 😎",
            ],
            installment: null,
          },
          prices: {
            initial: { text: "Inversión inicial", value: "USD $3.900" },
            financed: { text: "Financiado", value: "USD $0" },
            discount: { text: "Ahorras", value: "USD $600 🔥" },
            total: { text: "Total", value: "USD $3.900" },
          },
        },
        {
          title: "DIFERIDO",
          content: {
            paymentDescription: [
              "Paga una ",
              "seña",
              " y el resto al conseguir trabajo",
            ],
            installment: "HASTA 24 CUOTAS MENSUALES",
          },
          prices: {
            initial: { text: "Inversión inicial", value: "USD $600" },
            financed: { text: "Financiado", value: "USD $3.700" },
            discount: { text: "Ahorras", value: "USD $200 🔥" },
            total: { text: "Total", value: "USD $4.300" },
          },
        },
        {
          title: "FULL DIFERIDO",
          content: {
            paymentDescription: ["", "Empieza a pagar al conseguir trabajo"],
            installment: "HASTA 24 CUOTAS MENSUALES",
          },
          prices: {
            initial: { text: "Inversión inicial", value: "USD $0 🔥" },
            financed: { text: "Financiado", value: "USD $4.500" },
            discount: { text: "Ahorras", value: "USD $0" },
            total: { text: "Total", value: "USD $4.500" },
          },
        },
      ],
    },
    // --------------------------------------------------------------- //
    Schedule: {
      title: "AGENDA",
      subtitle: ["Próximas ", "fechas"],
      errorLoadingCourses:
        "Oops! parece que hubo un error y no pudimos cargar los cursos... intenta nuevamente en unos segundos",
    },
    // --------------------------------------------------------------- //
    BookingMobileNextMonth: {
      typeText: "ONLINE EN VIVO",
      inscriptionTimeLimitText: "Cierre de inscripción:",
      lastPositionsText: "ÚLTIMAS VACANTES",
      noPositionsText: "NO HAY VACANTES",
      applyButtonContent: "Aplicar",
      applyButtonContentNotAvailable: "Proximamente",
      contents: [
        {
          img: {
            src: bookingNextMonthSFBCMonthsCalendarIcon,
            alt: "Calendario de mes",
          },
          title: "Fechas:",
        },
        {
          img: { src: bookingNextMonthSFBCClockIcon, alt: "Reloj" },
          title: "Horario:",
        },
        {
          img: { src: bookingNextMonthSFBCSheetIcon, alt: "Hoja" },
          title: "Duración:",
        },
        {
          img: { src: bookingNextMonthSFBCComputerIcon, alt: "Computadora" },
          title: "Modalidad:",
        },
        {
          img: {
            src: bookingNextMonthSFBCDaysCalendarIcon,
            alt: "Calendario de días",
          },
          title: "Días:",
        },
      ],
    },
    // --------------------------------------------------------------- //
    BookingMobile: {
      typeText: "ONLINE EN VIVO",
      inscriptionTimeLimitText: "Cierre de inscripción:",
      lastPositionsText: "ÚLTIMAS VACANTES",
      noPositionsText: "NO HAY VACANTES",
      applyButtonContent: "Aplicar",
      applyButtonContentNotAvailable: "Proximamente",
      contents: [
        {
          img: { src: bookingMonthsCalendarIcon, alt: "Calendario de mes" },
          title: "Fechas:",
        },
        { img: { src: bookingClockIcon, alt: "Reloj" }, title: "Horario:" },
        { img: { src: bookingSheetIcon, alt: "Hoja" }, title: "Duración:" },
        {
          img: { src: bookingComputerIcon, alt: "Computadora" },
          title: "Modalidad:",
        },
        {
          img: { src: bookingDaysCalendarIcon, alt: "Calendario de días" },
          title: "Días:",
        },
      ],
    },
    // --------------------------------------------------------------- //
    BookingDesktopNextMonth: {
      typeText: "ONLINE - EN VIVO",
      inscriptionTimeLimitText: "Cierre de inscripción: ",
      lastPositionsText: "ÚLTIMAS VACANTES",
      noPositionsText: "NO HAY VACANTES",
      applyButtonContent: "Aplicar",
      applyButtonContentNotAvailable: "Proximamente",
      contents: [
        {
          img: {
            src: bookingNextMonthSFBCMonthsCalendarIcon,
            alt: "Calendario de mes",
          },
          title: "Fechas:",
        },
        {
          img: { src: bookingNextMonthSFBCClockIcon, alt: "Reloj" },
          title: "Horario:",
        },
        {
          img: { src: bookingNextMonthSFBCSheetIcon, alt: "Hoja" },
          title: "Duración:",
        },
        {
          img: { src: bookingNextMonthSFBCComputerIcon, alt: "Computadora" },
          title: "Modalidad:",
        },
        {
          img: {
            src: bookingNextMonthSFBCDaysCalendarIcon,
            alt: "Calendario de días",
          },
          title: "Días:",
        },
      ],
    },
    // --------------------------------------------------------------- //
    BookingDesktop: {
      typeText: "ONLINE - EN VIVO",
      inscriptionTimeLimitText: "Cierre de inscripción: ",
      lastPositionsText: "ÚLTIMAS VACANTES",
      noPositionsText: "NO HAY VACANTES",
      applyButtonContent: "Aplicar",
      applyButtonContentNotAvailable: "Proximamente",
      contents: [
        {
          img: { src: bookingMonthsCalendarIcon, alt: "Calendario de mes" },
          title: "Fechas:",
        },
        { img: { src: bookingClockIcon, alt: "Reloj" }, title: "Horario:" },
        { img: { src: bookingSheetIcon, alt: "Hoja" }, title: "Duración:" },
        {
          img: { src: bookingComputerIcon, alt: "Computadora" },
          title: "Modalidad:",
        },
        {
          img: { src: bookingDaysCalendarIcon, alt: "Calendario de días" },
          title: "Días:",
        },
      ],
    },
    // --------------------------------------------------------------- //
    ATypicalDay: {
      title: ["Un día", " típico"],
      subtitle: [
        "Estos serán tus horarios durante la Junior Phase del Bootcamp",
      ],
      program: "100% virtual",
    },
    // --------------------------------------------------------------- //
    ATypicalDayMobile: {
      clockImg: { src: clockIcon, alt: "Reloj" },
      data: [
        {
          text: "9:30 ARG",
          description: "PREPARACIÓN DEL DÍA",
          width: "275px",
        },
        { text: "10:00 ARG", description: "LECTURES", width: "275px" },
        { text: "11:00 ARG", description: "WORKSHOPS", width: "184px" },
        { text: "13:00 ARG", description: "ALMUERZO Y RELAX", width: "275px" },
        {
          text: "14:00 ARG",
          description: "WORKSHOP (CONTINUACIÓN)",
          width: "275px",
        },
        {
          text: "17:00 ARG",
          description: "Q&A: SESIÓN DE CONSULTAS",
          width: "275px",
        },
        { text: "18:00 ARG", description: "WORKSHOP", width: "275px" },
      ],
    },
    // --------------------------------------------------------------- //
    ATypicalDayDesktop: {
      clockImg: { src: clockIcon, alt: "Reloj" },
      altCircleImg: "Reloj",
      disclaimer:
        "*A partir de la semana 9, este cronograma tendrá algunas modificaciones, pero las actividades seguirán siendo full-time.",
      data: [
        {
          text: "9:30 ARG",
          description: "PREPARACIÓN DEL DÍA",
          width: "275px",
          content:
            "Revisa con cuidado el calendario y dale una mirada al plan de trabajo en Pledu. Aprovecha para revisar tus apuntes y anotar cualquier duda.",
        },
        {
          text: "10:00 ARG",
          description: "LECTURES",
          width: "275px",
          content:
            "En las lectures (clases teóricas) los profesores explicarán nuevos conceptos, con los que tendrás que trabajar después. Estas pueden ser en vivo o grabadas.",
        },
        {
          text: "11:00 ARG",
          description: "WORKSHOPS",
          width: "184px",
          content:
            "Durante el Workshop tendrás que realizar tareas, resolver problemas y profundizar tu conocimiento sobre algunos conceptos vistos en las lectures. A veces trabajarás de modo individual y a veces en equipos.",
        },
        {
          text: "13:00 ARG",
          description: "ALMUERZO Y RELAX",
          width: "275px",
          content: "",
        },
        {
          text: "14:00 ARG",
          description: "WORKSHOP (CONTINUACIÓN)",
          width: "275px",
          content:
            "Continuarás con el trabajo en las actividades y proyectos asignados y te prepararás para la sesión de consultas. Durante los Workshops contarás con la ayuda de asistentes para resolver tus inquietudes.",
        },
        {
          text: "17:00 ARG",
          description: "Q&A: SESIÓN DE CONSULTAS",
          width: "275px",
          content:
            "Esta sesión será grupal y en vivo. Te permitirá despejar tus dudas con los profesores, aprovechar las consultas de los demás y consolidar los aprendizajes del día.",
        },
        {
          text: "18:00 ARG",
          description: "WORKSHOP",
          width: "275px",
          content:
            "Continuarás con las tareas asignadas y harás las entregas indicadas para esa jornada.",
        },
      ],
    },
    // --------------------------------------------------------------- //
    Testimonies: {
      testimonies: [
        {
          name: "FACUNDO GONZÁLEZ",
          description:
            "El Bootcamp en P5 es una experiencia hermosa. Los profesores explican muy bien y siempre están a disposición. Es un cambio de vida total, te abre muchos caminos en el mundo IT. ¡Salesforce es enorme y está lleno de oportunidades!",
          img: facundoGonzalez,
          companyImg: koibanxLogo,
        },
        {
          name: "ROSANGELYS REYES",
          description:
            "El Bootcamp en P5 fue una de mis mejores experiencias. Si alguien quiere hacer un salto en su carrera y está comprometido con eso, se lo recomiendo al 100 %. Requiere mucha dedicación, pero es muy llevadero, no te aburrís y te sentís acompañado. Además, como Salesforce es un mundo gigante, hay muchísimas áreas para desarrollarse laboralmente.",
          img: rosangelysReyes,
          companyImg: modelitIcon,
        },
        {
          name: "RODRIGO CADIZ",
          description:
            "Mi experiencia en P5 fue espectacular. ¡Un Bootcamp te permite dar un salto enorme! No sabía nada de programación y me convertí en developer. En P5 intentan que cada proyecto parezca un trabajo real, lo que te diferencia en el mercado laboral. ¡El Bootcamp de Salesforce es una super oportunidad!",
          img: rodrigoCadiz,
          companyImg: cloudGaiaIcon,
        },
        {
          name: "LEO CAMPOY",
          description:
            "Sin dudas recomendaría el Bootcamp. Es la ruta más rápida que conozco para meterse al mundo de la programación y conseguir el primer trabajo. Fue una experiencia muy intensa pero sobre todo muy divertida y desafiante.",
          img: leoCampoy,
          companyImg: cloudGaiaIcon,
        },
      ],
    },
    WantToApplyButton: {
      title: "Quiero aplicar",
    },
  },
  "/bootcamp/javascript": {
    // --------------------------------------------------------------- //
    BootcampTitle: {
      title: "JavaScript Bootcamp",
      subtitle: ["Aprende  JavaScript, ", "", "el lenguaje de la web."],
      poweredBy: "",
      companyImg: null,
      partnerImg: null,
      backgroundLogoImg: {
        src: javascriptMainBackgroundImg,
        alt: "Javascript Bootcamp representative background",
      },
    },
    // --------------------------------------------------------------- //
    BootcampText: {
      dotBackgroundImg: { src: dotBackgroundImg, alt: "Fondo de puntos" },
      content: [
        "JavaScript es el ",
        "lenguaje más utilizado por las empresas tecnológicas",
        " de todo el mundo. ",
        "",
        "Conviértete en Desarrollador Web Full Stack y cambia tu vida para siempre.",
        "",
      ],
    },
    // --------------------------------------------------------------- //
    BenefitsTitle: {
      title: "BENEFICIOS",
      subtitle: ["¿Por qué", " hacerlo?"],
    },
    // --------------------------------------------------------------- //
    CardsBenefitsMobile: {
      cards: [
        {
          img: { src: javascriptCupIcon, alt: "Copa" },
          title: "INSERCIÓN LABORAL",
          subtitle:
            "Súmate a nuestros más de 550 graduados que ya trabajan en programación.",
        },
        {
          img: { src: javascriptPCIcon, alt: "Computadora" },
          title: "REMOTO",
          subtitle:
            "Trabaja desde cualquier parte del mundo en la industria del futuro.",
        },
        {
          img: { src: javascriptGroupIcon, alt: "Versátil" },
          title: "VERSÁTIL",
          subtitle:
            "Desarrolla todo tipo de aplicaciones: Web, Desktop, Mobile y mucho más.",
        },
      ],
    },
    // --------------------------------------------------------------- //
    CardsBenefitsDesktop: {
      cards: [
        {
          img: { src: javascriptCupIcon, alt: "Copa" },
          title: "INSERCIÓN LABORAL",
          subtitle:
            "Todos nuestros graduados que buscaron trabajo lo consiguieron.",
        },
        {
          img: { src: javascriptPCIcon, alt: "Computadora" },
          title: "SALARIOS",
          subtitle:
            "Los programadores de Salesforce están entre los mejores pagos del mercado IT.",
        },
        {
          img: { src: javascriptGroupIcon, alt: "Versátil" },
          title: "9,3 MILLONES DE NUEVOS PUESTOS DE TRABAJO",
          subtitle:
            "Salesforce es una de las tecnologías con mayor crecimiento en el mundo.",
        },
      ],
    },
    // --------------------------------------------------------------- //
    CourseModalityCardsMobile: {
      title: "INTENSIVO",
      subtitle: ["Modalidad", " de cursada"],
      cards: [
        {
          img: { src: javascriptClockIcon, alt: "Reloj" },
          title: "FULL TIME",
          subtitle: ["Lunes a Viernes", "De 9:30 a 19:00 hs"],
        },
        {
          img: { src: javascriptCalendarIcon, alt: "Calendario" },
          title: "4 MESES",
          subtitle: ["", "Más de 800 hs. ", "de aprendizaje"],
        },
        {
          img: { src: javascriptComputerIcon, alt: "Computadora" },
          title: "REMOTO",
          subtitle: ["Curso 100% online Workshops en vivo"],
        },
      ],
    },
    // --------------------------------------------------------------- //
    CourseModalityCardsDesktop: {
      title: "INTENSIVO",
      subtitle: ["Modalidad de ", "cursada"],
      backgroundImg: { src: codeBackground, alt: "Fondo de código" },
      rightSideImg: {
        src: javascriptPersonCoding,
        alt: "Un chico de Salesforce codeando",
      },
      cards: [
        {
          img: { src: javascriptClockIcon, alt: "Reloj" },
          title: "FULL TIME",
          subtitle: ["Lunes a Viernes", "De 9:30 a 19:00 hs"],
        },
        {
          img: { src: javascriptCalendarIcon, alt: "Calendario" },
          title: "4 MESES",
          subtitle: ["", "Más de 800 hs. de aprendizaje"],
        },
        {
          img: { src: javascriptComputerIcon, alt: "Computadora" },
          title: "REMOTO",
          subtitle: ["Curso 100% online", "Workshops en vivo"],
        },
      ],
    },
    // --------------------------------------------------------------- //
    UnitsCarrousel: {
      title: "CONOCE MÁS",
      subtitle: "Programa",
      button: "Descarga el programa",
      units: [
        {
          unit: "PREP COURSE",
          stage: "",
          period: "80 horas",
          title: "JavaScript Prep",
          lessons: [
            { topic: "Command Line" },
            { topic: "Git" },
            { topic: "JavaScript en profundidad" },
          ],
        },
        {
          unit: "JUNIOR PHASE",
          stage: "",
          period: "",
          title: "Estructuras de datos",
          lessons: [
            { topic: "Queue (ADT)" },
            { topic: "Linked List (DS)" },
            { topic: "Binary Trees" },
            { topic: "Hash Tables" },
          ],
        },
        {
          unit: "JUNIOR PHASE",
          stage: "",
          period: "",
          title: "Selectores",
          lessons: [
            { topic: "Document Object Model (DOM)" },
            { topic: "DOM Tree" },
            { topic: "Selectores" },
            { topic: "Serialización" },
            { topic: "Tests" },
          ],
        },
        {
          unit: "JUNIOR PHASE",
          stage: "",
          period: "",
          title: "Sorting",
          lessons: [
            { topic: "Algoritmos de Ordenamiento" },
            { topic: "Bubble Sort" },
            { topic: "Merge Sort" },
            { topic: "Benchmarking" },
            { topic: "Insertion Sort y Heap Sort" },
          ],
        },
        {
          unit: "JUNIOR PHASE",
          stage: "",
          period: "",
          title: "Node.js",
          lessons: [
            { topic: "Bash" },
            { topic: "Built-in globals" },
            { topic: "Built-in modules" },
            { topic: "Node Package Manager (NPM)" },
            { topic: "Web Servers" },
            { topic: "Express" },
            { topic: "Auth" },
            { topic: "Axios" },
          ],
        },
        {
          unit: "JUNIOR PHASE",
          stage: "",
          period: "",
          title: "SQL",
          lessons: [
            { topic: "Base de Datos" },
            { topic: "Sentencias" },
            { topic: "QueriesSQL" },
            { topic: "Schema Design" },
            { topic: "PostgreSQL" },
          ],
        },
        {
          unit: "JUNIOR PHASE",
          stage: "",
          period: "",
          title: "Promesas (avanzado)",
          lessons: [
            { topic: "Estados" },
            { topic: "Vanilla Callbacks" },
            { topic: "Librería Mocha" },
            { topic: "Librería Bluebird" },
            { topic: "Métodos" },
          ],
        },
        {
          unit: "JUNIOR PHASE",
          stage: "",
          period: "",
          title: "HTML y CSS (avanzado)",
          lessons: [
            {
              topic: "Repaso avanzado de HTML",
            },
            {
              topic: "Flexbox",
            },
            {
              topic: "Sass",
            },
            { topic: "Media Query" },
          ],
        },
        {
          unit: "JUNIOR PHASE",
          stage: "",
          period: "",
          title: "React",
          lessons: [
            { topic: "Sintaxis JSX" },
            { topic: "React App" },
            { topic: "Hooks" },
            { topic: "React Router" },
            { topic: "Context" },
            { topic: "Redux" },
          ],
        },
        {
          unit: "JUNIOR PHASE",
          stage: "",
          period: "",
          title: "Developer Toolbox",
          lessons: [
            { topic: "Git / GitHub" },
            { topic: "Docker" },
            { topic: "Metodologías ágiles (Scrum)" },
            { topic: "Trello" },
            { topic: "R.E.A.C.T.O." },
          ],
        },
        {
          unit: "SENIOR PHASE",
          stage: "",
          period: "1 semana",
          title: "Solo Week",
          lessons: [
            { topic: "Desarrollo Full Stack" },
            { topic: "Manejo avanzado de API y package.json" },
            { topic: "Metodologías ágiles (SCRUM)" },
            { topic: "Implementación de Features - método MoSCoW" },
          ],
        },
        {
          unit: "SENIOR PHASE",
          stage: "",
          period: "2 semanas",
          title: "Proyecto Grupal",
          lessons: [
            { topic: "Desarrollo Full Stack" },
            { topic: "Metodologías ágiles (SCRUM)" },
            { topic: "Implementación de Features - método MoSCoW" },
            { topic: "Trabajo por sprints" },
            { topic: "Code review con jurado" },
            { topic: "Gestión de Proyectos" },
          ],
        },
        {
          unit: "SENIOR PHASE",
          stage: "",
          period: "4 semanas",
          title: "Práctica Profesional",
          lessons: [
            { topic: "Desarrollo Full Stack" },
            { topic: "Metodologías ágiles (SCRUM)" },
            { topic: "Implementación de Features - método MoSCoW" },
            { topic: "Trabajo por sprints" },
            { topic: "Gestión de Proyectos" },
            { topic: "Proyecto con empresas reales" },
            {
              topic: "Presentación de avances semanales con el cliente (demos)",
            },
          ],
        },
        {
          unit: "SENIOR PHASE",
          stage: "",
          period: "",
          title: "Experiencias",
          lessons: [
            { topic: "Pair-programming" },
            { topic: "Checkpoints" },
            { topic: "Tech Talks" },
            { topic: "Talking Circle" },
            { topic: "Encuentros con graduados y expertos" },
          ],
        },
        {
          unit: "POST BOOTCAMP",
          stage: "",
          period: "2 semanas",
          title: "Job Placement",
          lessons: [
            { topic: "Estrategia de búsqueda laboral" },
            { topic: "Preparación de CV + perfil en LinkedIn" },
            { topic: "Simulación de entrevistas" },
            { topic: "MeetUps con empresas IT" },
          ],
        },
      ],
    },
    // --------------------------------------------------------------- //
    Tools: {
      // -> TODO Sumar imágenes y que se vean dos filas con máximo 3 por fila idealmente
      // FIXME -> arreglar tamaños de las imágenes
      title: "HERRAMIENTAS",
      subtitle: "Aprenderás a usar",
      logosImg: [
        { src: jsLogo, alt: "Logo JavaScript" },
        { src: nodejsLogo, alt: "Logo Node.js" },
        { src: sqlLogo, alt: "Logo Sql" },
        { src: reactLogo, alt: "Logo React" },
        { src: reduxLogo, alt: "Logo Redux" },
        { src: expressLogo, alt: "Logo Express" },
        { src: mongodbLogo, alt: "Logo MongoDB" },
        { src: scrumLogo, alt: "Logo Scrum" },
        { src: commandLineLogo, alt: "Logo Command Line" },
        { src: gitLogo, alt: "Logo Git" },
        { src: githubLogo, alt: "Logo GitHub" },
      ],
    },
    Funding: {
      title: "INVERSIÓN",
      subtitle: ["", "Nuestros planes"],
      options: [
        "Contamos con ",
        "tres opciones:",
        " Contado, Diferido y Full Diferido.",
      ],
      note: "El 70 % de nuestros alumnos recibe algún tipo de financiación.",
      cards: [
        {
          title: "CONTADO",
          content: {
            paymentDescription: [
              "Paga de forma anticipada y aprovecha el ",
              "descuento 😎",
            ],
            installment: null,
          },
          prices: {
            initial: { text: "Inversión inicial", value: "USD $3.900" },
            financed: { text: "Financiado", value: "USD $0" },
            discount: { text: "Ahorras", value: "USD $600 🔥" },
            total: { text: "Total", value: "USD $3.900" },
          },
        },
        {
          title: "DIFERIDO",
          content: {
            paymentDescription: [
              "Paga una ",
              "seña",
              " y el resto al conseguir trabajo",
            ],
            installment: "HASTA 24 CUOTAS MENSUALES",
          },
          prices: {
            initial: { text: "Inversión inicial", value: "USD $600" },
            financed: { text: "Financiado", value: "USD $3.700" },
            discount: { text: "Ahorras", value: "USD $200 🔥" },
            total: { text: "Total", value: "USD $4.300" },
          },
        },
        {
          title: "FULL DIFERIDO",
          content: {
            paymentDescription: ["", "Empieza a pagar al conseguir trabajo"],
            installment: "HASTA 24 CUOTAS MENSUALES",
          },
          prices: {
            initial: { text: "Inversión inicial", value: "USD $0 🔥" },
            financed: { text: "Financiado", value: "USD $4500" },
            discount: { text: "Ahorras", value: "USD $0" },
            total: { text: "Total", value: "USD $4500" },
          },
        },
      ],
    },
    // --------------------------------------------------------------- //
    Schedule: {
      title: "AGENDA",
      subtitle: ["Próximas ", "fechas"],
      errorLoadingCourses:
        "Oops! parece que hubo un error y no pudimos cargar los cursos... intenta nuevamente en unos segundos",
    },
    // --------------------------------------------------------------- //
    BookingMobileNextMonth: {
      typeText: "ONLINE EN VIVO",
      inscriptionTimeLimitText: "Cierre de inscripción:",
      lastPositionsText: "ÚLTIMAS VACANTES",
      noPositionsText: "NO HAY VACANTES",
      applyButtonContent: "Aplicar",
      applyButtonContentNotAvailable: "Proximamente",
      contents: [
        {
          img: {
            src: bookingNextMonthJSBCMonthsCalendarIcon,
            alt: "Calendario de mes",
          },
          title: "Fechas:",
        },
        {
          img: { src: bookingNextMonthJSBCClockIcon, alt: "Reloj" },
          title: "Horario:",
        },
        {
          img: { src: bookingNextMonthJSBCSheetIcon, alt: "Hoja" },
          title: "Duración:",
        },
        {
          img: { src: bookingNextMonthJSBCComputerIcon, alt: "Computadora" },
          title: "Modalidad:",
        },
        {
          img: {
            src: bookingNextMonthJSBCDaysCalendarIcon,
            alt: "Calendario de días",
          },
          title: "Días:",
        },
      ],
    },
    // --------------------------------------------------------------- //
    BookingMobile: {
      typeText: "ONLINE EN VIVO",
      inscriptionTimeLimitText: "Cierre de inscripción:",
      lastPositionsText: "ÚLTIMAS VACANTES",
      noPositionsText: "NO HAY VACANTES",
      applyButtonContent: "Aplicar",
      applyButtonContentNotAvailable: "Proximamente",
      contents: [
        {
          img: { src: bookingMonthsCalendarIcon, alt: "Calendario de mes" },
          title: "Fechas:",
        },
        { img: { src: bookingClockIcon, alt: "Reloj" }, title: "Horario:" },
        { img: { src: bookingSheetIcon, alt: "Hoja" }, title: "Duración:" },
        {
          img: { src: bookingComputerIcon, alt: "Computadora" },
          title: "Modalidad:",
        },
        {
          img: { src: bookingDaysCalendarIcon, alt: "Calendario de días" },
          title: "Días:",
        },
      ],
    },
    // --------------------------------------------------------------- //
    // --------------------------------------------------------------- //
    BookingDesktopNextMonth: {
      typeText: " ONLINE - EN VIVO",
      inscriptionTimeLimitText: "Cierre de inscripción: ",
      lastPositionsText: "ÚLTIMAS VACANTES",
      noPositionsText: "NO HAY VACANTES",
      applyButtonContent: "Aplicar",
      applyButtonContentNotAvailable: "Proximamente",
      contents: [
        {
          img: {
            src: bookingNextMonthJSBCMonthsCalendarIcon,
            alt: "Calendario de mes",
          },
          title: "Fechas:",
        },
        {
          img: { src: bookingNextMonthJSBCClockIcon, alt: "Reloj" },
          title: "Horario:",
        },
        {
          img: { src: bookingNextMonthJSBCSheetIcon, alt: "Hoja" },
          title: "Duración:",
        },
        {
          img: { src: bookingNextMonthJSBCComputerIcon, alt: "Computadora" },
          title: "Modalidad:",
        },
        {
          img: {
            src: bookingNextMonthJSBCDaysCalendarIcon,
            alt: "Calendario de días",
          },
          title: "Días:",
        },
      ],
    },
    // --------------------------------------------------------------- //
    BookingDesktop: {
      typeText: " ONLINE - EN VIVO",
      inscriptionTimeLimitText: "Cierre de inscripción: ",
      lastPositionsText: "ÚLTIMAS VACANTES",
      noPositionsText: "NO HAY VACANTES",
      applyButtonContent: "Aplicar",
      applyButtonContentNotAvailable: "Proximamente",
      contents: [
        {
          img: { src: bookingMonthsCalendarIcon, alt: "Calendario de mes" },
          title: "Fechas:",
        },
        { img: { src: bookingClockIcon, alt: "Reloj" }, title: "Horario:" },
        { img: { src: bookingSheetIcon, alt: "Hoja" }, title: "Duración:" },
        {
          img: { src: bookingComputerIcon, alt: "Computadora" },
          title: "Modalidad:",
        },
        {
          img: { src: bookingDaysCalendarIcon, alt: "Calendario de días" },
          title: "Días:",
        },
      ],
    },
    // --------------------------------------------------------------- //
    ATypicalDay: {
      title: ["Un día", " típico"],
      subtitle: [
        "Estos serán tus horarios durante la Junior Phase del Bootcamp",
      ],
      program: "100% virtual",
    },
    // --------------------------------------------------------------- //
    ATypicalDayMobile: {
      clockImg: { src: clockIcon, alt: "Reloj" },
      data: [
        {
          text: "9:00 ARG",
          description: "CODEWARS",
          width: "275px",
        },
        { text: "9:30 ARG", description: "LECTURES", width: "275px" },
        { text: "11:00 ARG", description: "WORKSHOPS", width: "184px" },
        { text: "13:00 ARG", description: "ALMUERZO Y RELAX", width: "275px" },
        {
          text: "14:00 ARG",
          description: "WORKSHOP (CONTINUACIÓN)",
          width: "275px",
        },
        {
          text: "17:30 ARG",
          description: "CODE-REVIEW",
          width: "275px",
        },
        {
          text: "18:30 ARG",
          description: "Q&A: SESIÓN DE CONSULTAS",
          width: "275px",
        },
      ],
    },
    // --------------------------------------------------------------- //
    ATypicalDayDesktop: {
      clockImg: { src: clockIcon, alt: "Reloj" },
      disclaimer:
        "*A partir de la Senior Phase (semana 8), este cronograma tendrá algunas modificaciones, pero las actividades seguirán siendo full-time.",
      data: [
        {
          text: "9:00 ARG",
          description: "CODEWARS",
          content:
            "Todas las mañana harás ejercicios de JS Vainilla para despertar el cerebro y empezar bien el día. Actividad optativa.",
        },
        {
          text: "9:30 ARG",
          description: "LECTURES",
          content:
            "En las lectures (clases teóricas) los profesores explican nuevos conceptos, con los que tendrás que trabajar después. Estas pueden ser en vivo o grabadas.",
        },
        {
          text: "11:00 ARG",
          description: "WORKSHOPS",
          content:
            "Durante el Workshop resuelves un desafío práctico haciendo pair-programming. Para ello, te conectas con un co-equiper a través de una plataforma online con salas privadas y espacios de consulta grupal.",
        },
        {
          text: "13:00 ARG",
          description: "ALMUERZO Y RELAX",
          content: "",
        },
        {
          text: "14:00 ARG",
          description: "WORKSHOP (CONTINUACIÓN)",
          content:
            "Continúas el Workshop con tu pair-programming hasta la Code Review.",
        },
        {
          text: "17:30 ARG",
          description: "CODE-REVIEW",
          content:
            "Cada Code-review, o revisión del código modelo, está grabada para que puedas verla en cuanto termines el Workshop. Como hay muchas maneras de resolver cada desafío, puedes consultarla y comparar tus soluciones con las propuestas por el Dev Team.",
        },
        {
          text: "18:30 ARG",
          description: "Q&A: SESIÓN DE CONSULTAS",
          content:
            "Cuentas con una sesión grupal de Q&A en vivo al final de cada Code-Review, para que despejes tus dudas con los asistentes.",
        },
      ],
    },
    // --------------------------------------------------------------- //
    Testimonies: {
      testimonies: [
        {
          name: "Miguel Jesús Oyola",
          img: miguelJesusOyola,
          description:
            "Todo P5 es una locura, lleno de gente extremadamente buena onda y amable, siempre dispuestos a ayudar, es como una familia. En mi caso realicé no solo el Bootcamp, sino también el Curso Introductorio. Ambos procesos fueron excelentes. Acabo de terminar el Bootcamp y la verdad es que extraño estar con todas las personas con las que compartí esa experiencia. Es 100% recomendable en todos los niveles, personal y académico.",
          companyImg: logoInteratica,
        },
        {
          name: "Diego H. Rojas",
          img: diegoHRojas,
          description:
            "La verdad es que tienen un equipo de otro nivel, con profesores calificados y personas maravillosas. Cuentan con canales de comunicación donde hay una comunidad de devs buena onda, dispuestos a darte una mano en todo momento.Hace poco terminé el Bootcamp y puedo decir que fue una experiencia increíble, llena de desafíos y mucho aprendizaje. Además, lo que me gusta de P5 es que te ayudan a conseguir tu primer empleo en el mercado IT.Me quedo con la frase Confía en el proceso.  Para dar un salto de carrera, 100% recomendado.",
          companyImg: null,
        },
        {
          name: "Reynaldo Valencia",
          img: reynaldoValencia,
          description:
            "El Bootcamp de Plataforma 5 es una experiencia increíble. Además de que el contenido es explicado de manera muy fácil de entender, la comunidad de developers es increíble, son personas siempre dispuestas a ayudar. Siempre hay alguien listo para darte apoyo, tanto técnico como personal.Muy recomendado para alguien que quiere cambiar de carrera al mundo de IT, como fue mi caso, o para alguien que está dando sus primeros pasos profesionales en el mundo de las tecnologías de información.",
          companyImg: null,
        },
        {
          name: "Facundo Müller",
          img: facundoMuller,
          description:
            "Hermoso lugar para aprender tanto los conocimientos técnicos como las habilidades blandas que vas a necesitar en tu día a día como Dev, de la mano de un equipo de grandes personas que están presentes durante todo el camino y te brindan todas las herramientas para que puedas incorporar todo el conocimiento y egresar listo para comenzar a trabajar. Totalmente recomendado.",
          companyImg: peopleLogo,
        },
        {
          name: "Yesica Barros",
          img: yesicaBarros,
          description:
            "Para mí fue una experiencia maravillosa. Fue tan gratificante pasar de no saber programar y, gracias a todo el proceso de aprendizaje y el apoyo que recibí de parte de P5, lograr finalizar el Bootcamp y en una semana conseguir mi primer trabajo en IT. P5 realmente me potenció y me dio las herramientas necesarias para poder afrontar y superar cada desafío presente dentro de un mercado tan demandante y cambiante como lo es el del desarrollo de software.",
          companyImg: jpMorganLogo,
        },
        {
          name: "Julieta Puig Peralta",
          img: julietaPuigPeralta,
          description:
            "P5 siempre va a ser un lugar que ayudó a redefinir mis límites, a darme cuenta de mi potencial y conseguir oportunidades laborales muy valiosas. El Bootcamp es una experiencia que recomiendo para cualquier curioso de la programación. ¡La calidez humana y el profesionalismo nunca dejaron de sorprenderme!",
          companyImg: globantLogo,
        },
        {
          name: "Ignacio Rodríguez",
          img: ignacioRodriguez,
          description:
            "¡Hermoso haber transitado este camino junto a tantas personas que me ayudaron, enseñaron y acompañaron para que hoy pueda ser Full-Stack Developer! Gracias por la calidad humana y técnica por supuesto al staff de Plataforma 5 - Coding Bootcamp y a todos mis compañeros por generar entorno de trabajo muy, pero muy copado. [...]",
          companyImg: balloonLogo,
        },
        {
          name: "Maitén Peinetti",
          img: maitenPeinetti,
          description:
            "Feliz de poder compartirles este logro. 🎉 El Bootcamp fue una experiencia hermosa, llena de esfuerzo y desafíos. ¡Agradezco de corazón a todas las personas que me acompañaron, desde el staff de Plataforma 5 - Coding Bootcamp como todos mis compañeros! ¡Fue un placer transitar este camino con ustedes!",
          companyImg: checkboxLogo,
        },
        {
          name: "Julia Selma",
          img: juliaSelma,
          description:
            "Hoy hago esta publicación muy agradecida: Con mi familia por haberme acompañado en el intenso proceso de aprendizaje que elegí para dar el vuelco a mi vida profesional, los 4 hicimos un gran esfuerzo. Con Plataforma 5 - Coding Bootcamp por haberme dado herramientas para insertarme en este nuevo mercado que me apasiona y de donde me llevo un gran número de buenos amigos.",
          companyImg: IBMLogo,
        },
        {
          name: "Guillermo Federico Nauberger",
          img: guillermoFedericoNauberger,
          description:
            "Fueron 3 meses muy intensos y estoy muy agradecido por la oportunidad ya que me permitió hacer las dos cosas que más me gustan: aprender y programar. ¡Es increíble el impacto que tiene en la vida de uno hacer lo que le apasiona! Y mucho más compartiendo eso con otras personas. ¡Gracias Plataforma 5 - Coding Bootcamp por el acompañamiento, la organización y la excelente formación! ¡También gracias a Globant por confiar en nuestro equipo y guiarnos en nuestro proyecto profesional!",
          companyImg: globantLogo,
        },
        {
          name: "Claudio Mazzoli",
          img: claudioMazzoli,
          description:
            "[...] Estoy muy feliz y orgulloso de haber aprendido a absorber nuevas tecnologías en tan poco tiempo y de ver realizado este gran paso hacia nuevos rumbos en el mundo IT, en los cuales el aprendizaje es un loop infinito. Agradezco con todo el ❤️ a mi familia por haberme apoyado, a toda la gente de Plataforma 5 - Coding Bootcamp y en especial a mis compañeros, esperando que nos crucemos nuevamente en algún proyecto. [...]",
          companyImg: fizzmodLogo,
        },
      ],
    },
    WantToApplyButton: {
      title: "Quiero aplicar",
    },
  },
  "/": {
    HomeTitle: {
      title: ["Aprende a ", "programar", "Cambia ", "tu vida"],
      subtitle: ["Te acompañamos", " hasta ", "tu primer ", "trabajo en IT"],
      benefits: [
        {
          mobile: "✓ Bootcamp → 100% financiado",
          desktop: "✓ Bootcamp con 100% de financiación",
        },
        "✓ Trabaja con proyectos reales",
      ],
    },
    ApplyNowButton: {
      title: "Aplicar ahora",
    },
    Home: {
      ratings: [
        {
          mainText: "COURSE REPORT",
          ranking: "5/5",
          img: courseReportLogo,
          mb: "28px",
        },
        {
          mainText: "SWITCHUP",
          ranking: "4.89/5",
          img: switchUpLogo,
        },
      ],
    },
    P5Commitment: {
      title: "COMPROMISO P5",
      subtitle: ["Potenciar ", "tu ", "inserción laboral"],
      graduatesJob: "Nuestros graduados trabajan en:",
    },
    ProgrammingPath: {
      title: "¿CÓMO LO HACEMOS?",
      subtitle: ["Tu ", "camino ", "en ", "programación"],
      steps: [
        {
          title: "CURSO INTRODUCTORIO",
          subtitle:
            "Empieza desde cero y aprende las bases de la programación.",
          img: step1,
          path: "/intro",
        },
        {
          title: "CODING CHALLENGE",
          subtitle: "Rinde el examen de ingreso para nuestros Bootcamps.",
          img: step2,
          path: "/challenge",
        },
        {
          title: "CODING BOOTCAMP",
          subtitle: "JavaScript o Salesforce. Descubre cuál es para vos.",
          img: step3,
          path: "/bootcamp",
        },
        {
          title: "PRIMER TRABAJO IT",
          subtitle: "Trabaja en la industria con más oportunidades laborales.",
          img: step4,
          path: "",
        },
      ],
    },
    Funding: {
      title: "FINANCIACIÓN",
      subtitle: ["Paga cuando ", "consigas tu primer trabajo"],
    },
    LaborInsertion: {
      title: "JOB PLACEMENT",
      subtitle: "Trabajar en IT",
      laborInsertion: [
        "Al finalizar el Bootcamp, nuestro equipo de ",
        "Job Placement",
        " potencia tu perfil con:",
      ],
      jobPlacement: [
        {
          img: jobPlacement1,
          text: "Diseño de perfil profesional y estrategia de búsqueda laboral",
          marginBottom: "75px",
        },
        {
          img: jobPlacement2,
          text: "Armado y optimización de CV y perfil de LinkedIn",
          marginBottom: "75px",
        },
        {
          img: jobPlacement5,
          text: "Workshops con expertos en Recursos Humanos y empresas aliadas",
          marginBottom: "75px",
        },
        {
          img: jobPlacement7,
          text: "Bolsa de trabajo exclusiva",
          marginBottom: "75px",
        },
        {
          img: jobPlacement10,
          text: "Red de contactos con Reclutadores + graduados de P5",
          marginBottom: { xs: "31px", md: "75px" },
        },
      ],
    },
    Testimonies: {
      title: "TESTIMONIOS",
      subtitle: ["Más de ", "5.000 estudiantes ", "nos recomiendan"],
    },
    TestimoniesSlider: {
      videos: [
        "https://youtube.com/embed/y-UDMLso_lo",
        "https://youtube.com/embed/7gSdHLpwBLg",
        "https://youtube.com/embed/Uj-W2lCPKGc",
        "https://youtube.com/embed/EzFefTeULRs",
        "https://youtube.com/embed/J6uA7JptICI",
        "https://youtube.com/embed/7AESYfVynUY",
      ],
    },
    GetToKnowUs: {
      title: "CONÓCENOS DE CERCA",
      subtitle: {
        mobile: ["P5 en los", " medios"],
        desktop: ["Plataforma5 en los", " medios"],
      },
      media: [
        { img: CNNLogo, name: "CNN" },
        {
          img: laNacionLogo,
          name: "LN",
          link: "https://www.lanacion.com.ar/economia/negocios/cursos-intensivos-cualquiera-pueda-programar-nid07082021",
        },
        {
          img: diarioPerfilLogo,
          name: "PERFIL",
          link: "https://www.perfil.com/noticias/reperfilar/programacion-como-convertirte-en-un-experto-y-cambiar-de-carrera-en-solamente-4-meses.phtml",
        },
        {
          img: forbesLogo,
          name: "FORBES",
          link: "https://www.forbesargentina.com/negocios/forma-programadores-cuatro-meses-inserta-mercado-laboral-historia-plataforma-5-n12797",
        },
        {
          img: infobaeLogo,
          name: "INFOBAE",
          link: "https://www.infobae.com/opinion/2022/02/23/por-que-faltan-tantos-programadores-y-como-subsanarlo/",
        },
        {
          img: infoTechnologyLogo,
          name: "TECHNOLOGY",
          link: "https://www.cronista.com/infotechnology/it-business/en-plena-pandemia-capacitaron-a-mas-de-250-personas-que-hoy-trabajan-en-empresas-como-mercado-libre-globant-y-etermax/",
        },
      ],
    },
  },
  "/aplica": {
    HeroSection: {
      title: "¿En qué curso quieres anotarte?",
      subtitle: ["Por favor", "selecciona tu curso"],
    },
    Courses: {
      intro: {
        title: "CURSO INTRODUCTORIO",
        img: applyIntroLogo,
        description:
          "Aprende desde cero HTML, CSS, JavaScript, las bases de la programación.",
        hoverText: "¿EMPIEZAS DE CERO?",
      },
      jsbc: {
        title: "JAVASCRIPT BOOTCAMP",
        img: applyJSLogo,
        description:
          "Conquista una de las tecnologías centrales de la web y conviértete en un Developer Full Stack.",
        hoverText: "¿YA SABES PROGRAMAR?",
      },
      sfbc: {
        title: "SALESFORCE BOOTCAMP",
        img: applySalesforceLogo,
        description:
          "Aprende Apex y el ecosistema Salesforce y domina la plataforma de CRM más usada por las grandes empresas.",
        hoverText: "¿YA SABÉS PROGRAMAR?",
      },
    },
    ApplyButton: {
      title: "Quiero aplicar",
    },
  },
  "/aplica/javascript": {
    ApplyJavascript: {
      title: "JavaScript Bootcamp",
      description: [
        "Conquista una de las tecnologías centrales de la web y conviértete ",
        "en un Developer Full Stack.",
      ],
      img: jsbcBackgroundIcon,
      question: "¿Sabes programar?",
      negativeAnswer: {
        icons: "😕 💻",
        text: ["NO,", " ESTOY EMPEZANDO ", "DE CERO"],
        disclaimer:
          "Para aplicar a nuestros Coding Bootcamps necesitas tener bases de programación. Puedes aprender desde cero con nuestro Curso Introductorio.",
      },
      affirmativeAnswer: {
        icons: "🤓 💻",
        text: ["SÍ, ", "TENGO ", "CONOCIMIENTOS"],
        disclaimer:
          "Recuerda que para aplicar necesitas saber las bases de JavaScript: Variables, if/else, While y For loops, Funciones, Arreglos y Objetos.",
      },
    },
    IntroButton: {
      title: "Ir al intro",
    },
    WantToApplyButton: {
      title: "Quiero aplicar",
    },
    BackButton: {
      title: "Volver",
    },
  },
  "/aplica/salesforce": {
    ApplySalesforce: {
      title: "Salesforce Bootcamp",
      description: [
        "Aprende APEX y el ecosistema de Salesforce ",
        "y trabaja con una de las tecnologías más demandadas por las grandes empresas.",
      ],
      img: sfbcBackgroundIcon,
      question: "¿Sabes programar?",
      negativeAnswer: {
        icons: "😕 💻",
        text: ["NO,", " ESTOY EMPEZANDO ", "DE CERO"],
        disclaimer:
          "Para aplicar a nuestros Coding Bootcamps necesitas tener bases de programación. Puedes aprender desde cero con nuestro Curso Introductorio.",
      },
      affirmativeAnswer: {
        icons: "🤓 💻",
        text: ["SÍ, ", "TENGO ", "CONOCIMIENTOS"],
        disclaimer:
          "Recuerda que para aplicar necesitas saber las bases de JavaScript: Variables, if/else, While y For loops, Funciones, Arreglos y Objetos.",
      },
    },
    IntroButton: {
      title: "Ir al intro",
    },
    WantToApplyButton: {
      title: "Quiero aplicar",
    },
    BackButton: {
      title: "Volver",
    },
  },
  "/aplica/intro": {
    ApplyIntro: {
      title: "Curso Introductorio",
      description: [
        "Aprende desde cero ",
        "HTML, CSS y JavaScript.",
        "Estas son las bases de la programación que te permitirán subir de nivel para realizar un Bootcamp.",
      ],
      img: introBackgroundIcon,
      subtitle: ["Por favor, ", "selecciona la modalidad"],
    },
    Modalities: {
      title: "CURSADA",
      description: "Elige la modalidad",
      modalityCardATR: {
        title: ["INTRO ", "ATR"],
        description: "ESTUDIA POR TU CUENTA",
        installment: { arg: "ÚNICO PAGO", rdm: "" },
        benefits: [
          { description: "Clases con profesor en vivo", isCon: true },
          { description: "Acceso ilimitado al curso" },
          { description: "+100 videos explicativos" },
          { description: "+100 ejercicios de práctica" },
          { description: "4 proyectos para tu portfolio" },
          { description: "Acceso a la comunidad P5" },
        ],
        applyButtonText: "Inscribirme",
      },
      modalityCardIntroTeacher: {
        title: ["INTRO ", "CON PROFESOR"],
        description: {
          arg: "6 CUOTAS SIN INTERÉS DE",
          rdm: "ESTUDIA CON CLASES EN VIVO",
        },
        installment: {
          arg: "TOTAL:",
          rdm: "",
        },
        benefits: [
          { description: "Mismo contenido del ATR", isPro: true },
          { description: "Clases con profesor en vivo" },
          { description: "Canal exclusivo de consultas" },
          { description: "Acompañamiento del staff" },
        ],
        applyButtonText: "Inscribirme",
      },
    },
    BackButton: {
      title: "Volver",
    },
  },
  "/aplica/intro/fechas": {
    ApplyIntroDates: {
      title: "Curso Introductorio",
      description: [
        "Aprende desde cero ",
        " HTML, CSS, JavaScript, las bases de la programación.",
      ],
      img: introBackgroundIcon,
      subtitle: ["Por favor, ", "selecciona la edición"],
    },
    BackButton: {
      title: "Volver",
    },
  },
  "/aplica/javascript/fechas": {
    ApplyJavascriptDates: {
      title: "JavaScript Bootcamp",
      description: [
        "Conquista una de las tecnologías centrales de la web y conviértete ",
        "en un Developer Full Stack.",
      ],
      img: jsbcBackgroundIcon,
      subtitle: ["Por favor, ", "selecciona la edición"],
    },
    BackButton: {
      title: "Volver",
    },
  },
  "/aplica/salesforce/fechas": {
    ApplySalesforceDates: {
      title: "Salesforce Bootcamp",
      description: [
        "Aprende APEX y el ecosistema de Salesforce ",
        "y trabaja con una de las tecnologías más demandadas por las grandes empresas.",
      ],
      img: sfbcBackgroundIcon,
      subtitle: ["Por favor, ", "selecciona la edición"],
    },
    BackButton: {
      title: "Volver",
    },
  },
  "/aplicar/payment": {
    ApplyEmail: {
      title: {
        intro: "¡Muchas gracias por comprar!",
        bootcamp:
          "¡Nos alegra que quieras convertirte en Full Stack Developer!",
      },
      img: {
        src: successIcon,
        alt: "Ícono de mano con pulgar arriba.",
      },
      description: [
        "Una vez confirmado tu pago, recibirás un ",
        "email ",
        "con el ",
        "primer paso",
        " del proceso de admisión.",
        "para acceder al ",
        "curso.",
        "En breve, recibirás un ",
      ],
      disclaimer: "(Por las dudas, revisa tu correo no deseado)",
      emailNotReceived: [
        "¿No te llegó el mail? Escríbenos a admisiones@plataforma5.la",
      ],
    },
    ApplyError: {
      img: {
        src: errorIcon,
        alt: "Ícono de mano con pulgar abajo.",
      },
      background: {
        src: errorBackground,
        alt: "Fondo de pantalla de error.",
      },
      title: "Tu solicitud no se completó",
      description:
        "Escríbenos a admisiones@plataforma5.la y te ayudaremos a solucionarlo.",
    },
  },
  "/aplica/intro/formulario": {
    ApplyForm: {
      title: "Curso Introductorio:",
      subtitle:
        "Aprende desde cero HTML, CSS, JavaScript, las bases de la programación.",
      backgroundImg: introBackgroundIcon,
    },
    Form: {
      unfilledFieldsError: "Por favor, completa todos los campos.",
      notCoincidentEmailError: "Las direcciones de email no coinciden.",
      invalidEmailError: "Por favor, ingresa un email válido.",
      title: "FINALIZA TU INSCRIPCIÓN",
      helper:
        "¿Tienes dudas con el proceso de inscripción? Escríbenos a admisiones@plataforma5.la",
      total: "Total a pagar:",
      payButtonText: {
        title: {
          intro: ["Ir a", { arg: "Mercado Pago", rdm: "PayPal" }],
          bootcamp: "Enviar",
        },
      },
    },
    BackButton: {
      title: "Volver",
    },
    ModalityCard: {
      title: "EMPIEZA HOY. MANEJA TUS TIEMPOS",
      online: "ONLINE",
      async: "ASÍNCRONO",
      modality: "ONLINE | ASÍNCRONO",
      shift: "TURNO",
    },
    BreadCrumbs: {
      crumbsText: [
        "Aplica",
        { atr: "Estudia por tu cuenta", introTeacher: "Con profesor" },
        "Finaliza tu inscripción",
      ],
    },
  },
  "/aplica/javascript/formulario": {
    ApplyForm: {
      title: "Javascript Bootcamp",
      subtitle:
        "Conquista una de las tecnologías centrales de la web y conviértete en un Developer Full Stack.",
      backgroundImg: jsbcBackgroundIcon,
    },
    Form: {
      unfilledFieldsError: "Por favor, completa todos los campos.",
      notCoincidentEmailError: "Las direcciones de email no coinciden.",
      invalidEmailError: "Por favor, ingresa un email válido.",
      title: "FINALIZA TU INSCRIPCIÓN",
      helper:
        "¿Tienes dudas con el proceso de inscripción? Escríbenos a admisiones@plataforma5.la",
      total: "Total a pagar:",
      payButtonText: {
        title: {
          intro: ["Ir a", { arg: "Mercado Pago", rdm: "PayPal" }],
          bootcamp: "Enviar",
        },
      },
    },
    BackButton: {
      title: "Volver",
    },
    ModalityCard: {
      title: "EMPIEZA HOY. MANEJA TUS TIEMPOS",
      online: "ONLINE",
      async: "ASÍNCRONO",
      modality: "ONLINE | ASÍNCRONO",
      shift: "TURNO",
    },
    BreadCrumbs: {
      crumbsText: [
        "Aplica",
        { atr: "Estudia por tu cuenta", introTeacher: "Con profesor" },
        "Finaliza tu inscripción",
      ],
    },
  },
  "/aplica/salesforce/formulario": {
    ApplyForm: {
      title: "Salesforce Bootcamp",
      subtitle:
        "Aprende APEX y el ecosistema de Salesforce y trabaja con una de las tecnologías más demandadas por las grandes empresas.",
      backgroundImg: sfbcBackgroundIcon,
    },
    Form: {
      unfilledFieldsError: "Por favor, completa todos los campos.",
      notCoincidentEmailError: "Las direcciones de email no coinciden.",
      invalidEmailError: "Por favor, ingresa un email válido.",
      title: "FINALIZA TU INSCRIPCIÓN",
      helper:
        "Tienes dudas con el proceso de inscripción? Escríbenos a admisiones@plataforma5.la",
      total: "Total a pagar:",
      payButtonText: {
        title: {
          intro: ["Ir a", { arg: "Mercado Pago", rdm: "PayPal" }],
          bootcamp: "Enviar",
        },
      },
    },
    BackButton: {
      title: "Volver",
    },
    ModalityCard: {
      title: "EMPIEZA HOY. MANEJA TUS TIEMPOS",
      online: "ONLINE",
      async: "ASÍNCRONO",
      modality: "ONLINE | ASÍNCRONO",
      shift: "TURNO",
    },
    BreadCrumbs: {
      crumbsText: [
        "Aplica",
        { atr: "Estudia por tu cuenta", introTeacher: "Con profesor" },
        "Finaliza tu inscripción",
      ],
    },
  },
  "/intro": {
    Welcome: {
      title: {
        mobile: ["Curso Introductorio", "Tu primer paso en programación."],
        desktop: ["Curso", "Introductorio", "Tu primer paso en programación."],
      },
      subtitle: ["Aprende desde cero y ", "descubre si programar es para vos."],
      applyButtonTitle: "Quiero aplicar",
      description:
        "Aprende HTML, CSS y JavaScript y lleva tu carrera al siguiente nivel en un Bootcamp.",
      backgroundImg: introBackground,
      introIconImg: introIcon,
    },
    BenefitsSection: {
      title: "BENEFICIOS",
      description: ["¿Por qué", " hacerlo?"],
      group: {
        title: "HTML, CSS Y JAVASCRIPT",
        description: "Aprende los tres lenguajes con más demanda del mundo.",
        img: {
          src: htmlCSSJSIcon,
          alt: "HTML, CSS y JavaScript",
        },
      },
      learn: {
        title: "APRENDE HACIENDO",
        description:
          "Programa desde el día 1 y termina el curso con tus primeros proyectos de portfolio.",
        img: {
          src: learnIcon,
          alt: "Computadora",
        },
      },
      remote: {
        title: "ESTUDIA DESDE DONDE QUIERAS",
        description:
          "Nuestros cursos se dictan 100% online para que aprendas desde cualquier parte del mundo.",
        img: {
          src: worldIcon,
          alt: "Mundo",
        },
      },
    },
    UnitsCarrousel: {
      title: "CONOCE MÁS",
      subtitle: "Programa",
      units: [
        {
          unit: "Clase 1",
          title: "HTML",
          lessons: [
            { topic: "Introducción a internet" },
            { topic: "Introducción a HTML" },
            {
              topic: "Tipos de tags, tags con atributos y tags auto-contenidos",
            },
            { topic: "Publicación de páginas online" },
          ],
        },
        {
          unit: "Clase 2",
          title: "HTML",
          lessons: [
            { topic: "Introducción a CSS" },
            { topic: "Selectores CSS" },
            { topic: "Selectores avanzados" },
            { topic: "ID y Clase" },
          ],
        },
        {
          unit: "Clase 3",
          title: "Formularios HTML",
          lessons: [
            { topic: "Divs y Spans" },
            { topic: "Formularios" },
            { topic: "Otros tipos de inputs" },
          ],
        },
        {
          unit: "Clase 4",
          title: "CSS Modelo de caja y posicionamiento.",
          lessons: [
            { topic: "Pseudo selectores" },
            { topic: "Box model" },
            { topic: "Posicionamiento" },
            { topic: "Flexbox" },
          ],
        },
        {
          unit: "Clase 5",
          title: "CSS Frameworks",
          lessons: [
            { topic: "Introducción a Bootstrap" },
            { topic: "Sitios responsive" },
            { topic: "Componentes" },
          ],
        },
        {
          unit: "Clase 6",
          title: "Proyecto I: Tu Portfolio",
          lessons: [
            { topic: "Elaboración de Single-Page Application con HTML y CSS" },
          ],
        },
        {
          unit: "Clase 7",
          title: "Introducción a JavaScript",
          lessons: [
            { topic: "Introducción a JavaScript" },
            { topic: "Tipos de datos" },
            { topic: "Variables" },
            { topic: "ES6: Template Literals" },
          ],
        },
        {
          unit: "Clase 8",
          title: "If/Else",
          lessons: [
            { topic: "Estructura condicional if - else" },
            { topic: "Operadores lógicos y de comparación" },
            { topic: "Operador Ternario" },
          ],
        },
        {
          unit: "Clase 9",
          title: "While Loop",
          lessons: [
            { topic: "Estructura repetitiva while" },
            { topic: "Acumuladores y contadores" },
            { topic: "Objeto Math" },
          ],
        },
        {
          unit: "Clase 10",
          title: "Funciones",
          lessons: [
            { topic: "Declaración y llamado de una Función" },
            { topic: "Manejo de Funciones con múltiples parámetros" },
            { topic: "Keyword return" },
            { topic: "ES6:  Arrow Functions y Parámetros por default" },
          ],
        },
        {
          unit: "Clase 11",
          title: "Arreglos",
          lessons: [
            { topic: "Creación y acceso a los valores de un Arreglo" },
            { topic: "Métodos de Arreglos: push, pop, indexOf, etc." },
            { topic: "Iteración de Arreglos: For Loop y ForEach" },
            { topic: "Métodos de Arreglos en ES6: map, reduce, filter" },
          ],
        },
        {
          unit: "Clase 12",
          title: "Objetos",
          lessons: [
            { topic: "Creación y acceso a los valores de un Objeto" },
            { topic: "Modificando Objetos" },
            { topic: "Recorriendo un Objeto" },
          ],
        },
        {
          unit: "Clase 13",
          title: "Manipulando el DOM",
          lessons: [
            { topic: "¿Qué es el DOM?" },
            {
              topic:
                "Manipulación de texto, estilo y contenidos de los elementos",
            },
            { topic: "getAttribute() y setAttribute()" },
          ],
        },
        {
          unit: "Clase 14",
          title: "Eventos",
          lessons: [
            { topic: "¿Qué es un Evento?" },
            {
              topic:
                "Diferentes Eventos: click, mouseover, mouseleave,  keydown, etc.",
            },
            { topic: "Argumentos de un Evento" },
            { topic: "Producción de un juego: Typer D" },
          ],
        },
        {
          unit: "Clase 15",
          title: "Proyecto II: Color Game",
          lessons: [
            { topic: "Realización de un juego dinámico con JavaScript" },
          ],
        },
        {
          unit: "Clase 16",
          title: "POO (Programación Orientada a Objetos)",
          lessons: [
            { topic: "Paradigmas de programación" },
            { topic: "Clases" },
            { topic: "Objetos" },
            { topic: "Herencia" },
            { topic: "Objetos Nativos de JS" },
          ],
        },
        {
          unit: "Clase 17",
          title: "Proyecto II: To Do List",
          lessons: [
            {
              topic:
                "Realización de una herramienta de uso cotidiano con JavaScript",
            },
          ],
        },
        {
          unit: "Clase 18",
          title: "AJAX & JSON",
          lessons: [
            { topic: "Modelo Cliente - Servidor" },
            { topic: "AJAX & JSON" },
            { topic: "APIs" },
            {
              topic:
                "Proyecto IV: Realización de página con la utilización de API",
            },
          ],
        },
      ],
      downloadButtonText: "Descargar",
    },
    Technologies: {
      title: "HERRAMIENTAS",
      subtitle: ["Aprenderás", " a usar"],
    },
    TechnologiesCarrousel: {
      imgs: [
        VsCodeLogo,
        HtmlLogo,
        CssLogo,
        JsLogo,
        BootstrapLogo,
        JsonLogo,
        NetlifyLogo,
      ],
      alt: "tecnología",
    },
    ClassCard: {
      title: "Certifica tus logros",
      subtitle: [
        "Obtén tu certificado y ",
        "suma credenciales como programador.",
      ],
      img: { src: introCertificate, alt: "Certificado" },
    },
    Modalities: {
      title: "CURSADA",
      description: "Elige la modalidad",
      modalityCardATR: {
        title: ["INTRO ", "ATR"],
        description: "ESTUDIA POR TU CUENTA",
        installment: { arg: "ÚNICO PAGO", rdm: "" },
        benefits: [
          { description: "Clases con profesor en vivo", isCon: true },
          { description: "Acceso ilimitado al curso" },
          { description: "+100 videos explicativos" },
          { description: "+100 ejercicios de práctica" },
          { description: "4 proyectos para tu portfolio" },
          { description: "Acceso a la comunidad P5" },
        ],
        applyButtonText: "Inscribirme",
      },
      modalityCardIntroTeacher: {
        title: ["INTRO ", "CON PROFESOR"],
        description: {
          arg: "6 CUOTAS SIN INTERÉS DE",
          rdm: "ESTUDIA CON CLASES EN VIVO",
        },
        installment: {
          arg: "TOTAL:",
          rdm: "",
        },
        benefits: [
          { description: "Mismo contenido del ATR", isPro: true },
          { description: "Clases con profesor en vivo" },
          { description: "Canal exclusivo de consultas" },
          { description: "Acompañamiento del staff" },
        ],
        applyButtonText: "Inscribirme",
      },
    },
    Booking: {
      load: {
        title: "AGENDA",
        subtitle: ["Próximas ", "fechas con profesor"],
      },
      err: {
        title:
          "Oops! parece que hubo un error y no pudimos cargar las clases... intenta nuevamente en unos segundos",
      },
      normal: {
        title: "AGENDA",
        subtitle: "Intro con Profesor",
        nextDates: "Próximas fechas",
      },
    },
    YourPace: {
      title: "Intro ATR",
      subtitle: [
        "Si sos ",
        "autodidacta y quieres estudiar por tu cuenta,",
        " súmate a la opción ATR y ",
        "aprende a tu ritmo",
        " con nuestro contenido en video.",
      ],
      buttonText: "Inscribirme",
    },
    Community: {
      title: "Comunidad P5",
      subtitle:
        "Súmate al Curso Introductorio y accede a los beneficios de nuestra comunidad en Discord. Comparte tus dudas, memes, experiencias y aprende acompañado. ¡Ya somos más de 5.000 personas!",
      buttonText: "Quiero ser parte",
    },
  },
  "/challenge": {
    CodingChallengeTitle: {
      title: "Coding Challenge",
      subtitle: [
        "Si dominas los temas del Curso Introductorio, rinde el ",
        "Coding Challenge",
        " para ingresar a nuestros ",
        "Bootcamps.",
      ],
    },
    WantToApplyButton: {
      title: "Quiero aplicar",
    },
    CodingChallengeText: {
      description: [
        "El proceso de admisión consta de 5 ejercicios nivelatorios, un examen ",
        "técnico en vivo y una entrevista personal.",
      ],
      img: {
        src: dotBackgroundChallengeImg,
        alt: "background",
      },
    },
    Benefits: {
      title: "ADMISIÓN AL BOOTCAMP",
      subtitle: ["Etapas del ", "proceso"],
    },
    StagesMobile: {
      exercises: {
        img: {
          src: checkListIcon,
          alt: "Lista de tareas",
        },
        title: "EJERCICIOS NIVELATORIOS",
        subtitle:
          "Responde correctamente los 5 ejercicios de nivelación para completar la primera etapa.",
      },
      codingChallenge: {
        img: {
          src: cupIcon,
          alt: "Copa",
        },
        title: "CODING CHALLENGE",
        subtitle: "Realiza un examen técnico propio de P5.",
      },
      personalInterview: {
        img: {
          src: chatIcon,
          alt: "Chat",
        },
        title: "ENTREVISTA PERSONAL",
        subtitle:
          "En la última etapa, tendrás una entrevista de admisión final para evaluar tus habilidades blandas.",
      },
    },
    WantToStartButton: {
      title: "Quiero empezar",
    },
    StagesDesktop: {
      exercises: {
        img: {
          src: checkListIcon,
          alt: "Lista de tareas",
        },
        title: "EJERCICIOS NIVELATORIOS",
        subtitle:
          "Responde correctamente los 5 ejercicios de nivelación para completar la primera etapa.",
      },
      codingChallenge: {
        img: {
          src: cupIcon,
          alt: "Copa",
        },
        title: "CODING CHALLENGE",
        subtitle: "Realiza un examen técnico propio de P5.",
      },
      personalInterview: {
        img: {
          src: chatIcon,
          alt: "Chat",
        },
        title: "ENTREVISTA PERSONAL",
        subtitle:
          "En la última etapa, tendrás una entrevista de admisión final para evaluar tus habilidades blandas.",
      },
    },
    BeforeStarting: {
      backgroundImg: {
        src: "https://miro.medium.com/max/1400/1*LfkcONwFbCs5baybR2ZMcw.jpeg",
        alt: "Grupo de personas",
      },
      title: "PREPÁRATE",
      subtitle: "Antes de empezar",
      greenCheckImg: {
        src: greenCheckIcon,
        alt: "Check verde",
      },
      list: [
        "Si todavía no sabes programar, empieza por nuestro Curso Introductorio.",
        [
          "Si estás estudiando ",
          "para el Challenge, súmate a nuestro Discord.",
        ],
        "Si sabes programar, postúlate directamente.",
      ],
    },
    AdmissionProcessButton: {
      title: "Empezar ya",
    },
    CourseModality: {
      title: "CODING CHALLENGE",
      subtitle: "Dinámica",
      description:
        "Es un desafío técnico individual para evaluar tus conocimientos de JavaScript.",
    },
    CodingChallengeRemote: {
      remote: {
        title: "REMOTO",
        description: ["Sesión online", "en vivo"],
        img: {
          src: challengeComputerIcon,
          alt: "Computadora",
        },
      },
      exercises: {
        title: "5 EJERCICIOS",
        description: ["80 min.", "para resolverlos"],
        img: {
          src: challengeTimeIcon,
          alt: "Reloj",
        },
      },
      free: {
        title: "GRATUITO",
        description: ["Martes 19hs (ARG)", "con cita previa"],
        img: {
          src: challengeCalendarIcon,
          alt: "Calendario",
        },
      },
    },
    CodingChallengeTopics: {
      title: "JAVASCRIPT",
      subtitle: "¿Qué temas entran?",
    },
    TopicsMobile: {
      topics: [
        "Variables",
        "If/Else",
        "While y For Loops",
        "Funciones",
        "Arreglos",
        "Objetos",
      ],
      greenCheck: {
        src: greenCheckIcon,
        alt: "Check verde",
      },
    },
    TopicsDesktop: {
      topics: [
        "Variables",
        "If/Else",
        "While y For Loops",
        "Funciones",
        "Arreglos",
        "Objetos",
      ],
      greenCheck: {
        src: greenCheckIcon,
        alt: "Check verde",
      },
    },
  },
  "/bootcamp": {
    LandingBootcamp: {
      courseReport: {
        title: "COURSE REPORT",
        ranking: "5/5",
        img: {
          src: courseReportLogo,
          alt: "Course Report",
        },
      },
      switchUp: {
        title: "SWITCHUP",
        ranking: "4.89/5",
        img: {
          src: switchUpLogo,
          alt: "SwitchUp",
        },
      },
    },
    LandingTitle: {
      title: "Coding Bootcamp",
      description: [
        "Cursos de entrenamiento intensivo",
        " que garantizan ",
        "el ingreso a la industria IT.",
      ],
    },
    TakeTheLeap: {
      title: "ELIGE EL TUYO",
      subtitle: "Nuestros Bootcamps",
      grid: { src: gridBackground, alt: "Grilla" },
      sfbc: {
        title: "SALESFORCE BOOTCAMP",
        subtitle:
          "Especialízate en una tecnología de alta demanda que muy pocos dominan.",
        icon: {
          src: salesforceIcon,
          alt: "Salesforce",
        },
        card: {
          src: salesforceCard,
          alt: "Salesforce",
        },
      },
      jsbc: {
        title: "JAVASCRIPT BOOTCAMP",
        subtitle:
          "Conviértete en Full Stack Developer y desarrolla aplicaciones de todo tipo.",
        icon: {
          src: javascriptIcon,
          alt: "JavaScript",
        },
        card: {
          src: javascriptCard,
          alt: "JavaScript",
        },
      },
    },
    FounderTestimony: {
      founderImg: {
        src: founderPicture,
        alt: "Foto del fundador de P5",
      },
      words: `"Somos el primer Coding Bootcamp de Argentina y uno de los tres
      primeros de América Latina. Muchísimos graduados confiaron en esta
      experiencia. Aprenderás de forma intensiva, rápida y práctica".`,
      identity: ["Santiago Scanlan", "CEO - Founder"],
    },
  },
  "/nosotros": {
    HeroSection: {
      heroTitle: "CONOCE PLATAFORMA 5",
      section: "NUESTRA HISTORIA",
      introTitle: "Primer Coding Bootcamp de Argentina",
      intro: [
        "“Empecé ",
        "P5 ",
        "porque quería ",
        "aprender a programar ",
        "y no sabía por dónde empezar. Después de pasar mucho tiempo haciendo cursos online sin un camino claro, encontré los ",
        "Coding Bootcamp ",
        "que recién aparecían en Estados Unidos, y decidí traer el formato a Latinoamérica para ayudar a otros que estuvieran en mi lugar”.",
      ],
      introAuthor: "Santi Scanlan | CEO - Founder",
      heroextDesktop: "¡Nos apasiona lo que hacemos y siempre vamos por más!",
      hero: [
        "Nuestro objetivo es ",
        "ayudarte ",
        "a conseguir ",
        "tu primer ",
        "trabajo en programación",
        ", no importa tu edad ni de dónde vengas.",
      ],
    },
    Motivation: {
      sections: [
        {
          section: "PLATAFORMA EDUCATIVA",
          sectionDescription: "PLEDU",
          info: [
            "Sencilla e intuitiva, nuestra plataforma favorece a que la experiencia de nuestros estudiantes sea completa y guiada. Aprender a programar a nivel profesional requiere de muchísimas horas de práctica, y sobre todo de mucha determinación. ¡Simplifica tu experiencia con Pledu!",
          ],
        },
        {
          section: "NUESTROS VALORES",
          sectionDescription: "Invertimos en tu éxito",
          info: [
            [
              "Nuestros alumnos confían en este proceso para ",
              "cambiar su futuro",
              ". Por eso, con cada inscripción asumimos el compromiso de que lo logren. Ya sea acompañándolos en los momentos de frustración, con el mejor contenido e incluso financiando a quienes lo necesiten.",
            ],
            [
              "También, creemos que el ",
              "compromiso debe ser mutuo",
              ". Quien ingresa al Bootcamp tiene que comprometerse con dar el 100% para llegar hasta el final exitosamente.",
            ],
          ],
        },
      ],
    },
  },
  "/faqs": {
    HeroSection: {
      title: "Preguntas Frecuentes",
      info: "Resuelve tus dudas con esta selección de preguntas más consultadas",
    },
    Faqs: [
      {
        section: "TUS PREGUNTAS",
        title: "Curso Introductorio",
        questions: [
          {
            question:
              "¿Cuál es la diferencia entre el Curso Introductorio con Profesor y el ATR?",
            text: [
              "El Curso Introductorio de Programación tiene dos modalidades: ATR y con Profesor. **El contenido es el mismo.** La diferencia es que con el ATR cursas **A Tu Ritmo (asincrónico)** mientras que con Profesor tienes tres clases sincrónicas por semana con profesores y asistentes. El ATR empieza y termina cuando quieras, en cambio, ** con Profesor la duración es de seis semanas.**",
            ],
          },
          {
            question: "¿Hay un límite de edad para anotarme?",
            text: [
              "No. Para nosotros **la edad no es una limitante** y consideramos que tampoco lo es para insertarse laboralmente en el rubro de IT. La edad de nuestros estudiantes va desde 16 años hasta más de 55 años.",
            ],
          },
          {
            question: "¿Qué computadora necesito para cursar?",
            text: [
              "Para realizar el Curso Introductorio puedes utilizar cualquier sistema operativo (Linux, Windows, Mac). Una **notebook con un procesador Intel Core i3 y 4GB de memoria RAM está perfecto.**",
              "Si tienes pensado hacer un Coding Bootcamp te recomendamos ya tener una computadora con un procesador i5, 8GB de memoria RAM y 125 GB de memoria disponible en el disco.",
              "Además, ten en cuenta que para el JavaScript Bootcamp se requiere el uso de sistema operativo Linux o Mac.",
            ],
          },
          {
            question: "¿Entregan una certificación al terminar?",
            text: [
              "Sí. En Plataforma 5 apuntamos a un nuevo sistema educativo centrado en la práctica y en los resultados demostrables.",
              "Una vez que hayas finalizado el Curso Introductorio y entregado los proyectos prácticos a desarrollar, **recibirás un certificado** que avala los conocimientos adquiridos.",
            ],
          },
          {
            question: "¿Puedo conseguir trabajo luego del Curso Introductorio?",
            text: [
              "En el Curso Introductorio trabajas con el **front-end de sitios y aplicaciones web**, algo que tiene mucha demanda en el mercado laboral.",
              "Sin embargo, si tu objetivo es  insertarte en el mundo IT y dar un salto de carrera, te recomendamos nuestros **Coding Bootcamps.** Podrás convertirte en Full Stack Developer especializado en JavaScript o en Salesforce.",
            ],
          },
          {
            question: "¿Hay clases en vivo para las personas que cursamos ATR?",
            text: [
              "No. Puedes reforzar tus conocimientos de JavaScript con nuestras clases grabadas en Youtube.",
            ],
          },
          {
            question:
              "¿A quién le puedo consultar mis dudas técnicas si estoy cursando ATR?",
            text: [
              "Utilizamos la plataforma **Discord** para comunicarnos. Puedes escribir en los canales específicos y la Comunidad P5 te ayudará en lo que necesites. Asimismo, te sugerimos contestar preguntas de otras personas, mirar y comentar trabajos e inspeccionar su código para seguir aprendiendo de manera colaborativa.",
            ],
          },
          {
            question: "¿Puedo cambiarme de “ATR” a “Con Profesor”?",
            text: [
              "Sí. Para hacerlo, envíanos un mail a admisiones@plataforma5.la",
              "Se te cobrará el monto diferencial que hay entre las dos modalidades.",
            ],
          },
          {
            question:
              "¿Si apruebo el Curso Introductorio tengo que hacer el Coding Challenge?",
            text: [
              "Sí. El Curso Introductorio te brinda las herramientas necesarias para rendir el Coding Challenge. Sin embargo, todas **las personas que quieran ingresar a nuestros Coding Bootcamps deben aprobar el examen técnico de admisión.**",
            ],
          },
        ],
      },
      {
        section: "TUS PREGUNTAS",
        title: "Coding Challenge",
        questions: [
          {
            question: "¿Qué es el Coding Challenge?",
            text: [
              "El Coding Challenge es el examen técnico de admisión a nuestros Coding Bootcamps.",
              "Si ya dominas los conceptos del Curso Introductorio, inicia tu proceso de admisión a nuestros Coding Bootcamps completando el formulario de ejercicios nivelatorios.",
            ],
          },
          {
            question: "¿Qué temas entran en el Coding Challenge?",
            text: [
              "**Variables, If/Else, While y For Loops, Funciones, Arreglos y Objetos de JavaScript.**",
              "Practica mucho cada uno de estos temas hasta dominarlos para tener éxito en tu Challenge.",
            ],
          },
          {
            question: "¿El proceso de admisión al Coding Bootcamp es gratuito?",
            text: [
              "**Sí.** El proceso de admisión al Coding Bootcamp **es completamente gratuito.** ",
            ],
          },
          {
            question: "¿Cómo es la dinámica del Coding Challenge?",
            text: [
              "Es un **examen sincrónico** de 5 ejercicios que escalan en dificultad en la plataforma Qualified. Se realiza **a través de una videollamada** en día y horario a pactar.",
            ],
          },
          {
            question:
              "¿El Coding Challenge es el mismo para el JavaScript Bootcamp o el Salesforce Bootcamp?",
            text: [
              "Sí. **El proceso de admisión es el mismo** para todos los Coding Bootcamps.",
            ],
          },
          {
            question: "¿Puedo rendir el Coding Challenge más de una vez?",
            text: [
              "Sí. El Coding Challenge puede rendirse **hasta dos veces** en cada edición de Bootcamp.",
            ],
          },
          {
            question:
              "Si no pude entrar en una edición del Coding Bootcamp, ¿puedo volver a hacer la admisión en otro momento?",
            text: [
              "Sí. Es muy importante que quienes aspiren a ingresar a nuestros Coding Bootcamps sean perseverantes y mantengan el foco en sus objetivos.",
              "En caso de que **no apruebes la admisión técnica**, vamos a delinear juntos un **camino** para que puedas reforzar los conocimientos y **volver a intentarlo.** ",
            ],
          },
        ],
      },
      {
        section: "TUS PREGUNTAS",
        title: "Coding Bootcamp",
        questions: [
          {
            question: "¿Qué es un Coding Bootcamp?",
            text: [
              "Un **Coding Bootcamp** es un **curso intensivo de programación** de dedicación full-time que desarrolla tu talento y te inserta en el mercado laboral.",
              "Te formamos como **Full Stack Developer** (en JavaScript o Salesforce), un perfil de programador muy requerido en la industria del software. Vas a aprender a trabajar en equipo, incorporando las  **metodologías ágiles** en tu rutina diaria.",
              "En el último mes, aplicarás lo aprendido en **proyectos profesionales**. De esta manera, y de la mano de tus mentores técnicos, vas a ir sumando la experiencia necesaria para **conseguir tu primer trabajo.**",
            ],
          },
          {
            question:
              "¿Cuál es la diferencia entre el JavaScript y el Salesforce Bootcamp?",
            text: [
              "Aunque comparten el mismo proceso de admisión, horarios y modalidad de cursada, **el foco de cada Bootcamp está puesto en tecnologías diferentes.**",
              "**Salesforce** es un servicio que provee herramientas de CRM para las empresas. Se refiere al conjunto de prácticas, estrategias de negocio y tecnologías enfocadas en la relación con el cliente.",
              "**JavaScript** es un lenguaje de programación versátil que te brinda la habilidad de desarrollar tanto el frond-end como el back-end de sitios y aplicaciones web. Es el lenguaje más utilizado a nivel mundial.",
            ],
          },
          {
            question: "¿Los Coding Bootcamps tienen la misma duración?",
            text: [
              "Sí. Ambos respetan la **misma estructura y duración:**",
              "**• Bootcamp Prep:** Módulo de preparación donde incorporas herramientas fundamentales para comenzar el Coding Bootcamp. Duración: 3-4 semanas.",
              "**• Coding Bootcamp:** Clases teóricas, pair-programming, workshops y reviews para que incorpores los conceptos y  las herramientas FullStack. Duración: 14 semanas.",
              "**• Job Placement:** Te ayudamos a construir tu perfil profesional para potenciar tu inserción laboral. Duración: 2-3 semanas.",
              "_*Tanto el Bootcamp Prep como la etapa de Job Placement tienen una carga horaria part-time._",
            ],
          },
          {
            question:
              "¿Hay opciones de financiación para los Coding Bootcamps?",
            text: [
              "Sí. Contamos con **tres planes:**",
              "**Pago Full Diferido:** ¡Financiamos el 100% de tu Bootcamp! Empieza a pagar al conseguir tu primer empleo, en hasta 24 cuotas. El valor total es de USD 4.500.",
              "**Pago Diferido:** Abona un pago inicial mínimo de USD 600 y , el monto restante, lo empiezas a pagar recién cuando consigas tu primer empleo, en hasta 24 cuotas. El valor total es de USD 4.300. ",
              "**Pago De Contado:** Abona antes de iniciar el Coding Bootcamp en un único pago y aprovecha un descuento. El valor total es de USD 3.900. Ahorrás USD 600.",
            ],
          },
          {
            question: "¿Es requisito hablar inglés?",
            text: [
              "**El inglés no es requisito obligatorio**, pero te ayudará a comprender mejor la documentación y te permitirá acceder a material complementario para tu formación. Ten en cuenta también que algunas empresas pueden solicitar un nivel intermedio de inglés en sus búsquedas.",
            ],
          },
          {
            question: "¿Qué computadora necesito?",
            text: [
              "En el JavaScript Bootcamp utilizamos Linux o Mac. En cambio, en el de Salesforce, al ser todo Cloud, no se requiere un sistema operativo en particular.",
              "En ambos Bootcamps necesitas una **computadora con procesador i5, 8GB de memoria RAM y 125 GB de memoria disponible en el disco** es lo más conveniente. Si el presupuesto te lo permite, recomendamos un procesador i7, 12 GB de memoria RAM y 256 GB de memoria disponible.",
            ],
          },
          {
            question: "¿Me ayudan a conseguir trabajo?",
            text: [
              "En P5 **nos comprometemos a potenciar la búsqueda de empleo** de quienes egresan de nuestros Bootcamps.",
              "De la misma forma, **las personas que realizan el Bootcamp deben buscar activamente trabajo** para incrementar sus chances de éxito.",
              "Nuestro objetivo principal es que el 100% de nuestros bootcampers se inserte en el mercado laboral IT.",
            ],
          },
          {
            question:
              "En los planes financiados, ¿se cobra un porcentaje fijo de mi sueldo?",
            text: [
              "No. Una vez que **consigas tu primer trabajo** y según tu tipo de actividad laboral, el equipo de Administración armará un esquema a tu medida, **con un plan de pagos de hasta 24 cuotas mensuales** y consecutivas (para los planes “Pago Diferido” y “Full Diferido”).",
              "Antes de comenzar el Coding Bootcamp, con la **firma del Acuerdo de Pago** se explicitan las pautas importantes respecto a los tiempos de devolución y los montos. De esta forma, le damos un marco a tu compromiso de pago.",
            ],
          },
          {
            question: "¿Qué pasa si no consigo trabajo?",
            text: [
              "Desde P5 vamos a **formarte en todas las skills necesarias para implementar una estrategia de búsqueda laboral exitosa**. Sin embargo, recae en ti la responsabilidad última de conseguir el trabajo, ya que eres tú quien va a buscar empleos, postularse e ir a las entrevistas.",
              "Al finalizar el bootcamp deberás asumir el compromiso de entrar en Búsqueda Laboral Activa (BLA) y perseverar en ella hasta lograr el objetivo de tu primer trabajo en IT. Si bien los tiempos de inserción varían caso a caso, **todos nuestros graduados que perseveran en la búsqueda logran el objetivo**.",
            ],
          },
        ],
      },
      {
        section: "TUS PREGUNTAS",
        title: "Job Placement",
        questions: [
          {
            question: "¿Qué significa Job Placement?",
            text: [
              "El área de Job Placement de Plataforma 5 interviene para acompañar a quienes egresan de un Bootcamp en su inserción laboral. El equipo te ofrecerá herramientas para el desarrollo de tu estrategia profesional: armado de CV, perfil en redes sociales laborales y entrevistas grupales con empresas (Recruiting Weeks)",
            ],
          },
          {
            question: "¿Qué implica buscar activamente trabajo?",
            text: [
              "Buscar activamente trabajo significa **realizar de manera sistematizada, periódica y proactiva acciones para aumentar la probabilidad de conseguir un primer empleo como developer.** Esto implica tener una estrategia de búsqueda, diseñar un plan con objetivos generales y específicos, y realizar acciones todos los días para acercarse a la meta planteada.",
            ],
          },
          {
            question: "¿Qué son las Recruiting Weeks?",
            text: [
              "A través de decenas de encuentros virtuales, breves y grupales, tendemos un **puente entre los bootcampers y una gran variedad de empresas empleadoras** para acercarlos a su primer trabajo.",
              "Además, organizamos **Webinars** sobre temas destacados para la industria de la programación o sobre recursos útiles para potenciar su inserción laboral.",
            ],
          },
        ],
      },
    ],
  },
};

export default en;
